(function LivePlanner($, Adzuki)
{
	"use strict";

	var lp_video_window       = null;
	var redirect_warning      = true;
	var participants_interval = null;
	var active_interval       = null;
	var active_timeout        = 30000;

	var LivePlanner = function LivePlanner() {
		var dates,
			start_date,
			end_date,
			exclusions,
			find_criteria,
			self               = this,
			category_types     = ['inside', 'oceanview', 'balcony', 'suite'],
			travel_type        = null,
			summary_page_width = 900,
			note_length        = 50,
			actively_sending   = false,
			$primary_container = $('.live-planner-container'),
			group_session      = parseInt($primary_container.data('group-session')),
			start_video        = parseInt($primary_container.data('start-video')),
			criteria_count     = 0,
			itinerary_ids      = [],
			resort_ids         = [],
			category_codes     = [],
			screen_min_width   = 1440,
			screen_min_height  = 800,
			attributes_arrays  = {
				length     : [],
				destination: [],
				ship       : [],
				port       : [],
				amenity    : [],
				advantage  : [],
				tours      : [],
			},
			$results_map,
			client_stage_template,
			results_map, // eslint-disable-line no-unused-vars
			results_data,
			styles             =  [
				{
					featureType: "all",
					elementType: "geometry.fill",
					stylers    : [
						{
							weight: "2.00"
						}
					]
				},
				{
					featureType: "all",
					elementType: "geometry.stroke",
					stylers    : [
						{
							color: "#9c9c9c"
						}
					]
				},
				{
					featureType: "all",
					elementType: "labels.text",
					stylers    : [
						{
							visibility: "on"
						}
					]
				},
				{
					featureType: "landscape",
					elementType: "all",
					stylers    : [
						{
							color: "#f2f2f2"
						}
					]
				},
				{
					featureType: "landscape",
					elementType: "geometry.fill",
					stylers    : [
						{
							color: "#ffffff"
						}
					]
				},
				{
					featureType: "landscape.man_made",
					elementType: "geometry.fill",
					stylers    : [
						{
							color: "#ffffff"
						}
					]
				},
				{
					featureType: "poi",
					elementType: "all",
					stylers    : [
						{
							visibility: "off"
						}
					]
				},
				{
					featureType: "road",
					elementType: "all",
					stylers    : [
						{
							saturation: -100
						},
						{
							lightness: 45
						}
					]
				},
				{
					featureType: "road",
					elementType: "geometry.fill",
					stylers    : [
						{
							color: "#eeeeee"
						}
					]
				},
				{
					featureType: "road",
					elementType: "labels.text.fill",
					stylers    : [
						{
							color: "#7b7b7b"
						}
					]
				},
				{
					featureType: "road",
					elementType: "labels.text.stroke",
					stylers    : [
						{
							color: "#ffffff"
						}
					]
				},
				{
					featureType: "road.highway",
					elementType: "all",
					stylers    : [
						{
							visibility: "simplified"
						}
					]
				},
				{
					featureType: "road.arterial",
					elementType: "labels.icon",
					stylers    : [
						{
							visibility: "off"
						}
					]
				},
				{
					featureType: "transit",
					elementType: "all",
					stylers    : [
						{
							visibility: "off"
						}
					]
				},
				{
					featureType: "water",
					elementType: "all",
					stylers    : [
						{
							color: "#46bcec"
						},
						{
							visibility: "on"
						}
					]
				},
				{
					featureType: "water",
					elementType: "geometry.fill",
					stylers    : [
						{
							color: "#c8d7d4"
						}
					]
				},
				{
					featureType: "water",
					elementType: "labels.text.fill",
					stylers    : [
						{
							color: "#070707"
						}
					]
				},
				{
					featureType: "water",
					elementType: "labels.text.stroke",
					stylers    : [
						{
							color: "#ffffff"
						}
					]
				}
			];

		// --- Public functions ---
		// --- CPMaxx enotifyd event handlers ---
		this.cpmaxxEventHandler = function cpmaxxEventHandler(eventData) {
			// ignore any events that are not meant for the /LivePlanner/session page
			if (!$('body').hasClass('lp-session')) {
				return;
			}

			switch (eventData['eventType']) {
				case 'confirm_received':
					$('.lp-extra-loader').removeClass('lp-extra-loader-active');
					actively_sending = false;
				break;
				case 'receive_acceptance':
					document.location =  Adzuki.erez_url + Adzuki.base_uri + '/LivePlanner/session/' + eventData['lp_session_id'];
				break;
				case 'receive_client_view':
					// self.refreshLog();
				break;
				case 'receive_refresh':
					// self.refreshLog();
				break;
				case 'receive_rejection':
					if ($('.modal-body')) {
						$('.modal-body').html('Client has rejected the session. Feel free to close this window to continue.');
					} else {
						Adzuki.StatusMessage(null, 'Your client rejected the request to start the session. You will be redirected in 5 seconds.', 'Session rejected');

						setTimeout(
							function _redirection () {
								document.location = Adzuki.base_uri + '/LivePlanner/index';
							},
							5000
						);
					}
				break;
				case 'receive_video_rejection':
					if (group_session) {
						Adzuki.Ajax.get('/LivePlanner/getVideoRejectionStatus')
						.then(function _rejectionStatus(response) {
							if (response.error) {
								return;
							}

							// group session and no participants have joined video
							// nothing else to do, just close the video window
							if (parseInt(response.joined_count) === 0) {
								$('.lp-end-video').trigger('click', true);

								Adzuki.StatusMessage(null, 'Your client(s) rejected your video call, your video window has been closed', 'Video call rejected');
							}
						});
					} else {
						$('.lp-end-video').trigger('click', true);

						Adzuki.StatusMessage(null, 'Your client rejected your video call, your video window has been closed', 'Video call rejected');
					}
				break;
				case 'receive_end_video':
					$('.lp-switch-video-row').addClass('hidden');
					$('.lp-start-video').removeClass('hidden').data('started', 0);
					$('.lp-end-video').addClass('hidden').data('ended', 1);
				break;
				case 'receive_not_supported_video':
					if (group_session) {
						Adzuki.Ajax.get('/LivePlanner/getVideoRejectionStatus')
						.then(function _rejectionStatus(response) {
							if (response.error) {
								return;
							}

							// group session and no participants have joined video
							// nothing else to do, just close the video window
							if (parseInt(response.joined_count) === 0) {
								Adzuki.StatusMessage(null, 'Your client\'s web browser does not support Zoom, press "OK" to close your video window', 'Zoom not supported', {
									onClose: function _onCloseAlert() {
										// end the video meeting if it was started
										if ($('.lp-start-video').hasClass('hidden')) {
											$('.lp-end-video').trigger('click', true);
										}
									}
								});
							}
						});
					} else {
						// this is peer to peer, nothing else to do just close the video window
						Adzuki.StatusMessage(null, 'Your client\'s web browser does not support Zoom, press "OK" to close your video window', 'Zoom not supported', {
							onClose: function _onCloseAlert() {
								// end the video meeting if it was started
								if ($('.lp-start-video').hasClass('hidden')) {
									$('.lp-end-video').trigger('click', true);
								}
							}
						});
					}
				break;
				case 'secondary_join':
					updateParticipantCount();
					// self.refreshLog();
				break;
				case 'send_cruise_line':
					start_date = moment(eventData['start_date']);
					end_date   = moment(eventData['end_date']);

					showSailings(
						start_date.format('YYYY-MM-DD'),
						end_date.format('YYYY-MM-DD'),
						eventData['cruise_line_id']
					);
					// self.refreshLog();
				break;
				case 'send_started':
					Adzuki.Ajax.get('/LivePlanner/setLpSession/' + eventData['lpSessionId'])
					.then(function _receiveContent(content) {
						// self.refreshLog();
					});
				break;
				case 'waiting_disclaimer':
					$('.modal-body').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Waiting for client acknowledgement of session terms/conditions.');
					// self.refreshLog();
				break;
				case 'close_video_window':
					if (lp_video_window && !lp_video_window.closed) {
						lp_video_window.close();
					}
				break;
				case 'left_video':
					// do nothing
				break;
				default:
					console.log('1. invalid event type passed');
				break;
			}

			return;
		};

		// --- Agent's website enotifyd event handlers ---
		this.webEventHandler = function webEventHandler(eventData) {
			var link = eventData['link'];

			// ignore any events that are not meant for the /LivePlanner/index page
			// with the exception of "start_session" and "resume" so the client
			// can start/resume it's end of the LP session no matter which page they are on
			if (
				eventData['eventType'] !== 'start_session'
				&& eventData['eventType'] !== 'resume'
				&& !$('body').hasClass('lp-session')
			) {
				return;
			}

			if (window.console !== undefined) {
				console.log('Received Web Event: ' + eventData['eventType'] + ' :: ' + JSON.stringify(eventData));
			}

			switch (eventData['eventType']) {
				case 'end_session':
					redirect_warning     = false;
					window.location.href = Adzuki.base_uri + '/LivePlanner/endSession/' + eventData['lp_session_id'];
					break;
				case 'end_video':
					$('.lp-web-switch-to-video').addClass('hidden');
					$('.lp-web-join-video').addClass('hidden');

					if (lp_video_window) {
						Adzuki.StatusMessage(null, eventData['agent_name'] + ' has ended video for this consultation.', 'Video call ended');

						lp_video_window = null;
					}

					break;
				case 'receive_amenities':
					Adzuki.Ajax.get('/LivePlanner/propertyAmenities/' + eventData['property_id'] )
					.then(function _receiveAmenities(content) {
						$primary_container.html(content);
						$('.live-planner-contents').get(0).scrollIntoView();
						playSound();
					});
					break;
				case 'receive_all_inclusives':
					$(".live-planner-brand").html("<b>Company:</b> " + eventData['brand']);
					break;
				case 'receive_bucket_item':
					Adzuki.Ajax.get('/LivePlanner/bucketItem/' + eventData['item_id'])
					.then(function _receiveContent(content) {
						$primary_container.html(content);

						$('html, body').animate({
							scrollTop: $('.live-planner-city').offset().top
						}, 500);

						playSound();
					});
				break;
				case 'receive_city':
					Adzuki.Ajax.get('/LivePlanner/city/' + eventData['city_id'] + '/' + eventData['itinerary_id'])
					.then(function _receiveContent(content) {
						$primary_container.html(content);

						webWeather();
						playSound();

						$('html, body').animate({
							scrollTop: $('.live-planner-city').offset().top
						}, 500);
					});
				break;
				case 'receive_cruisetour':
					Adzuki.Ajax.get('/LivePlanner/cruisetour/' + eventData['cruisetour_id'] + '/' + eventData['itinerary_id'])
					.then(function _receiveContent(content) {
						$primary_container.html(content);

						webWeather();
						playSound();

						$('html, body').animate({
							scrollTop: $('.live-planner-cruisetour').offset().top
						}, 500);
					});
				break;
				case 'receive_collection_item':
					Adzuki.Ajax.get('/LivePlanner/collectionItem/' + eventData['collection_item_id'] + '/' + eventData['collection_item_type'])
					.then(function _receiveContent(content) {
						$primary_container.html(content);

						$('#modalWindow').modal('hide');

						$('.live-planner-dates').html(eventData['collection_title']);

						$('html, body').animate({
							scrollTop: $('#lp-collection-body').offset().top
						}, 500);

						playSound();
					});
				break;
				case 'receive_content':
					Adzuki.Ajax.get('/LivePlanner/content/' + eventData['external_ship_id'] + '/' + eventData['content_type'] + '/' + eventData['itinerary_id'])
					.then(function _receiveContent(content) {
						$primary_container.html(content);

						$('.live-planner-content-list').slick({
							dots        : false,
							slidesToShow: (eventData['content_type'] === 'decks' ? 1 : 4),
							arrows      : true,
							responsive  : [
								{
									breakpoint: 992,
									settings  : {
										slidesToShow: 3,
									}
								},
								{
									breakpoint: 830,
									settings  : {
										slidesToShow: 2,
									}
								},
								{
									breakpoint: 768,
									settings  : {
										slidesToShow: 1,
									}
								}
							]
						});

						if (eventData['content_type'] === 'decks') {
							Adzuki.MagnifierGlass('.adz-magnifier-container');
						}

						webWeather();
						playSound();

						$('html, body').animate({
							scrollTop: $('.live-planner-content-list').offset().top
						}, 500);
					});
				break;
				case 'receive_cruise_line':
					$(".live-planner-brand").html("<b>Company:</b> " + eventData['brand']);
				break;
				case 'receive_custom_file':
					Adzuki.Ajax.get('/LivePlanner/customFile/' + encodeURIComponent(eventData['file']))
					.then(function _receiveOffer(content) {
						$primary_container.html(content);

						if (eventData['comments'].length > 0) {
							$primary_container.find('.comments').html('<div class="alert alert-info"><b><i class="fas fa-info-circle"></i></b> ' + eventData['comments'] + '</div>');
						}

						$('.live-planner-contents').get(0).scrollIntoView();
						playSound();
					});
				break;
				case 'receive_custom_image':
					Adzuki.Ajax.get('/LivePlanner/customImage/' + encodeURIComponent(eventData['image']))
					.then(function _receiveOffer(content) {
						$primary_container.html(content);

						if (eventData['comments'].length > 0) {
							$primary_container.find('.comments').html('<div class="alert alert-info"><b><i class="fas fa-info-circle"></i></b> ' + eventData['comments'] + '</div>');
						}

						$('.live-planner-contents').get(0).scrollIntoView();
						playSound();
					});
				break;
				case 'receive_custom_link':
					Adzuki.CustomConfirm({
						title  : 'Decision Time',
						content: 'Would you like to visit  ' + eventData['name'] + '? Clicking \'YES\' will open the website in a new tab.',
						confirm: function confirm() {
							Adzuki.Ajax.get('/LivePlanner/visited/' + encodeURIComponent(eventData['name']))
							.then(function _receiveOffer(content) {
								// self.refreshLog();
							});

							window.open(
								eventData['link'],
								'_blank'
							);
						}
					});

					playSound();
				break;
				case 'receive_custom_pricing':
					Adzuki.Ajax.get('/LivePlanner/customPricing/' + eventData['itinerary_id'])
					.then(function _receiveCustomPricing(content) {
						$primary_container.html(content);

						if (eventData['comments'].length > 0) {
							$primary_container.find('.comments').html('<div class="alert alert-info"><b><i class="fas fa-info-circle"></i></b> ' + eventData['comments'] + '</div>');
						}

						category_types.forEach(category => {
							if (eventData[category].length > 0) {
								if (eventData[category] > 0) {
									$primary_container.find('.lp-custom-' + category + '-container').removeClass('hidden');
									$primary_container.find('.lp-custom-' + category).html(accounting.formatMoney(eventData[category]));
								} else {
									$primary_container.find('.lp-custom-' + category + '-container').addClass('hidden');
								}
							} else {
								$primary_container.find('.lp-custom-' + category + '-container').addClass('hidden');
							}
						});

						$('html, body').animate({
							scrollTop: $('.comments').offset().top
						}, 500);

						playSound();
					});
				break;
				case 'receive_custom_property_pricing':
					Adzuki.Ajax.get('/LivePlanner/customPropertyPricing/' + eventData['property_id'] + '/' + eventData['session_id'])
					.then(function _receiveCustomPricing(content) {
						$primary_container.html(content);

						if (eventData['comments'].length > 0) {
							$primary_container.find('.comments').html('<div class="alert alert-info"><b><i class="fas fa-info-circle"></i></b> ' + eventData['comments'] + '</div>');
						}

						$('html, body').animate({
							scrollTop: $('.comments').offset().top
						}, 500);

						playSound();
					});
				break;
				case 'receive_custom_video':
					Adzuki.Ajax.get('/LivePlanner/customVideo/' + encodeURIComponent(eventData['video']))
					.then(function _receiveCustomVideo(content) {
						$primary_container.html(content);

						if (eventData['comments'].length > 0) {
							$primary_container.find('.comments').html('<div class="alert alert-info"><b><i class="fas fa-info-circle"></i></b> ' + eventData['comments'] + '</div>');
						}

						$('.live-planner-contents').get(0).scrollIntoView();
						playSound();
					});
				break;
				case 'receive_dates':
					dates      = eventData['dates'];
					start_date = moment(dates.start_date);
					end_date   = moment(dates.end_date);

					Adzuki.Ajax.get('/LivePlanner/dates/' + start_date.format('YYYY-MM-DD') + '/' + end_date.format('YYYY-MM-DD'))
					.then(function _receiveOffer(content) {
						$('.live-planner-dates').html(content);
					});
				break;
				case 'receive_individual_content':
					Adzuki.Ajax.get('/LivePlanner/individualContent/' + eventData['name'] + '/' + eventData['id'] + '/' + eventData['itinerary_id'])
					.then(function _receiveOffer(content) {
						$primary_container.html(content);

						if (eventData['name'] === 'ship_decks') {
							Adzuki.MagnifierGlass('.adz-magnifier-container');
						}

						webWeather();
						playSound();

						$('html, body').animate({
							scrollTop: $('.live-planner-contents').offset().top
						}, 500);

						self.sendReceived();
					});
				break;
				case 'receive_link':
					Adzuki.CustomConfirm({
						title  : 'Decision Time',
						content: 'Would you like to visit the ' + eventData['name'] + ' page? Clicking \'YES\' will open the page in a new tab.',
						confirm: function confirm() {
							Adzuki.Ajax.get('/LivePlanner/visited/' + encodeURIComponent(eventData['name']))
							.then(function _receiveOffer(content) {
								// self.refreshLog();
							});

							if (link.indexOf('http') > -1) {
								window.open(
									link,
									'_blank'
								);
							} else {
								window.open(
									Adzuki.base_uri + link,
									'_blank'
								);
							}
						}
					});

					playSound();
				break;
				case 'receive_offer':
					Adzuki.Ajax.get('/LivePlanner/offer/' + eventData['offer_id'] + '/' + eventData['itinerary_id'] + '/' + eventData['comment'])
					.then(function _receiveOffer(content) {
						$primary_container.html(content);

						webWeather();
						playSound();

						$('.live-planner-contents').get(0).scrollIntoView();
					});
				break;
				case 'receive_overview':
					Adzuki.Ajax.get('/LivePlanner/overview/' + eventData['itinerary_id'])
					.then(function _receiveOffer(content) {
						$primary_container.html(content);

						webWeather();
						playSound();

						$('.live-planner-container').get(0).scrollIntoView();
					});
				break;
				case 'receive_property_overview':
					Adzuki.Ajax.get('/LivePlanner/propertyOverview/' + eventData['property_id'])
					.then(function _receiveOffer(content) {
						$primary_container.html(content);
						$('.live-planner-contents').get(0).scrollIntoView();
						playSound();
					});
				break;
				case 'receive_property_photo':
					Adzuki.Ajax.get('/LivePlanner/propertyPhoto/' + eventData['property_id'] + '/' + encodeURIComponent(eventData['photo_url']))
					.then(function _receiveOffer(content) {
						$primary_container.html(content);
						$('.live-planner-contents').get(0).scrollIntoView();
						playSound();
					});
				break;
				case 'receive_quick_quote':
					Adzuki.Ajax.get('/LivePlanner/cruiseQuickQuote/' + eventData['itinerary_id'] + '/' + eventData['session_id'])
					.then(function _receiveCruiseQuickQuote(content) {
						$primary_container.html(content);

						if (eventData['comments'].length > 0) {
							$primary_container.find('.comments').html('<div class="alert alert-info"><b><i class="fas fa-info-circle"></i></b> ' + eventData['comments'] + '</div>');
						}

						webWeather();
						playSound();

						$('.live-planner-contents').get(0).scrollIntoView();
					});
					break;
				case 'receive_all_property_photos':
					Adzuki.Ajax.get('/LivePlanner/propertyPhotos/' + eventData['property_id'])
					.then(function _receiveContent(content) {
						$primary_container.html(content);

						$('.live-planner-content-list').slick({
							dots        : false,
							slidesToShow: 3,
							arrows      : true,
							responsive  : [
								{
									breakpoint: 992,
									settings  : {
										slidesToShow: 3,
									}
								},
								{
									breakpoint: 830,
									settings  : {
										slidesToShow: 2,
									}
								},
								{
									breakpoint: 768,
									settings  : {
										slidesToShow: 1,
									}
								}
							]
						});

						$(".live-planner-content-list ").get(0).scrollIntoView();
						playSound();
					});
				break;
				case 'receive_package':
					if (eventData['section'] === undefined) {
						eventData['section'] = 'all';
					}

					Adzuki.Ajax.get('/LivePlanner/package/' + eventData['fit_builder_id'] + '/' + eventData['section'])
					.then(function _receivePackage(content) {
						$primary_container.html(content);

						$results_map = $(".fit-map");
						results_data = $results_map.data('results');
						results_map  = new Adzuki.Map($results_map, {
							zoom  : 10,
							styles: styles,
							init  : function map_init(map) {
								map.populate(results_data.map);
								map.drawGuidelines();
							}
						});

						webWeather();
						playSound();

						$('.live-planner-container').get(0).scrollIntoView();

						self.sendReceived();
					});
				break;
				case 'receive_package_template':
					Adzuki.Ajax.get('/LivePlanner/packageTemplate/' + eventData['fit_builder_template_id'] + '/' + eventData['section'])
					.then(function _receivePackageTemplate(content) {
						$primary_container.html(content);

						$results_map = $(".fit-map");
						results_data = $results_map.data('results');
						results_map  = new Adzuki.Map($results_map, {
							zoom  : 10,
							styles: styles,
							init  : function map_init(map) {
								map.populate(results_data.map);
								map.drawGuidelines();
							}
						});

						$('.live-planner-container').get(0).scrollIntoView();
						playSound();

						self.sendReceived();
					});
				break;
				case 'receive_pricing':
					Adzuki.Ajax.get('/LivePlanner/pricing/' + eventData['itinerary_id'])
					.then(function _receivePricing(content) {
						$primary_container.html(content);

						webWeather();
						playSound();

						$('.live-planner-pricing').get(0).scrollIntoView();
					});
				break;
				case 'receive_insurance':
					Adzuki.Ajax.get('/LivePlanner/insurance/' + eventData['itinerary_id'])
					.then(function _receiveInsurance(content) {
						$primary_container.html(content);

						webWeather();
						playSound();

						$('.live-planner-insurance').get(0).scrollIntoView();
					});
				break;
				case 'receive_raw_item':
					Adzuki.Ajax.get('/LivePlanner/rawItem/')
					.then(function _receiveOffer(content) {
						$primary_container.html(content);

						$('.lp-raw-name').html(eventData['title']);
						$('.lp-raw-supplier-name').html(eventData['supplier_name']);
						$('.lp-raw-image').html('<img src="' + eventData['item_image'] + '" class="img-responsive">');
						$('.lp-raw-description').html(eventData['item_description']);

						$('html, body').animate({
							scrollTop: $('.live-planner-contents').offset().top
						}, 500);

						playSound();
					});
				break;
				case 'receive_show_travel_selection':
					client_stage_template = '<img src="' + Adzuki.base_uri + '/images/liveplanner-logo.png" class="center-block" style="width: 450px">';
					client_stage_template += '<div style="background-color: #fcfcff"><img src="' + Adzuki.base_uri + '/images/liveplanner/travelling-essentials.gif" class="img-responsive center-block" style="max-height: 800px; "></div>';

					$('.live-planner-container').html(client_stage_template);
				break;
				case 'receive_type':
					client_stage_template = '<img src="' + Adzuki.base_uri + '/images/liveplanner-logo.png" class="center-block" style="width: 450px">';

					switch (eventData["travel_type"]) {
						case 'cruise':
							travel_type = 'Cruising';
							client_stage_template += '<div style="background-color: #fcfcff"><img src="' + Adzuki.base_uri + '/images/liveplanner/cruise.gif" class="img-responsive center-block" style="max-height: 800px; "></div>';

							break;
						case 'ais':
							travel_type = 'All-Inclusive Resorts';
							client_stage_template += '<div style="background-color: #fcfcff"><img src="' + Adzuki.base_uri + '/images/liveplanner/aip.gif" class="img-responsive center-block" style="max-height: 800px; "></div>';
							break;
						case 'fit':
							travel_type = 'Vacation Package';
							client_stage_template += '<div style="background-color: #fcfcff"><img src="' + Adzuki.base_uri + '/images/liveplanner/fit.gif" class="img-responsive center-block" style="max-height: 800px; "></div>';

							break;
						case 'collections':
							travel_type = 'Collections';
							client_stage_template += '<div style="background-color: #fcfcff"><img src="' + Adzuki.base_uri + '/images/liveplanner/book-location.gif" class="img-responsive center-block" style="max-height: 800px; "></div>';

							break;
						default:
							travel_type = 'Unknown';
							client_stage_template += '<div style="background-color: #fcfcff"><img src="' + Adzuki.base_uri + '/images/liveplanner/travelling-essentials.gif" class="img-responsive center-block" style="max-height: 800px; "></div>';

							break;
					}

					$('.live-planner-container').html(client_stage_template);

					Adzuki.Ajax.get("/LivePlanner/setType/" + eventData["travel_type"]).then(function _receiveOffer(content) {
						$(".live-planner-travel-type").html("<b>Type:</b> " + travel_type);

						switch (travel_type) {
							case 'All-Inclusive Resorts':
							case 'Vacation Package':
								$('.live-planner-dates').html('&nbsp;');
							break;
							case 'Cruising':
							default:
							break;
						}
					});

					// BELOW IS IF WE EVER WANT THE CLIENT TO CHOOSE THE BRAND
					// ------------------
					// switch (eventData['travel_type']) {
					// 	case 'cruise':
					// 		$primary_container.html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading cruise lines...');

					// 		Adzuki.Ajax.get('/LivePlanner/cruiseLines/')
					// 		.then(function _types(content) {
					// 			$primary_container.html(content);
					// 		});
					// 	break;
					// 	default:
					// 		console.log("nothin");
					// 	break;
					// }

					// container.html(html);
				break;
				case 'resume':
					if ($('.live-planner-container').length === 0) {
						Adzuki.CustomConfirm({
							title  : 'Decision Time',
							content: 'Ready to resume the session?',
							confirm: function confirm() {
								Adzuki.Ajax.get('/LivePlanner/resume/')
								.then(function _resume(content) {
									document.location = Adzuki.base_uri + '/LivePlanner/index/' + eventData['lp_session_id'];
								});
							}
						});
					}
				break;
				case 'start_session':
					Adzuki.CustomConfirm({
						title  : 'Decision Time',
						content: eventData['agent_name'] + ' has requested to start a live planning session with you. Ready to get started?',
						confirm: function confirm() {
							var url = '/LivePlanner/accept/';
							url += eventData['web_session_id'] + '/';
							url += eventData['cpmaxx_session_id'] + '/';
							url += eventData['client_id'] + '/';
							url += eventData['agent_id'];

							Adzuki.Ajax.get(url).then(function _accepted(response) {
								var url = Adzuki.base_uri + '/LivePlanner/index/';

								if (response.lp_session_id) {
									url += response.lp_session_id;
								}

								// done in case the client accepts a new session
								// while being on the stage of a "stale" session
								redirect_warning = false;

								// client accepted ok, redirect to LP stage
								document.location = url;
							});
						},
						cancel: function cancel() {
							var url = '/LivePlanner/reject/';
							url += eventData['agent_id'] + '/';
							url += eventData['cpmaxx_session_id'];

							Adzuki.Ajax.get(url).then(function _reject(content) {
								// nothing to do
							});
						}
					});
				break;
				case 'designate_primary':
					// client has been designated as the new primary client
					Adzuki.Ajax.get('/LivePlanner/designatePrimary')
					.then(function _designatePrimary(response) {
						Adzuki.StatusMessage('success', 'You are being designated as the new Primary Client for this LivePlanner consultation.');
					});
				break;
				case 'demote_participant':
					// client has been demoted to a participant, no notification is sent
					Adzuki.Ajax.get('/LivePlanner/demote');
				break;
				case 'session_completed':
					// this is a secondary client that is still in the session that was
					// abandoned but the agent never ended it
					Adzuki.Ajax.get('/LivePlanner/clientCheck/' + Adzuki.client_id)
					.then(function _clientCheck(response) {
						var primary_client = parseInt(response.lp_primary_client);

						// show popup to redirect to liveplanner landing page
						if (primary_client === 0) {
							Adzuki.StatusMessage('info', 'This session is no longer active. Click OK to return to your myTrips account.', 'Session Ended', {
								onClose: function _onCloseAlert() {
									redirect_warning = false;

									if (lp_video_window) {
										Cookies.set('lp_confirm_video_close', 0);

										lp_video_window.close();
										lp_video_window = null;
									}

									document.location = Adzuki.base_uri + '/LivePlanner/landing';
								}
							});
						}
					});
				break;
				case 'receive_library_video':
					Adzuki.Ajax.get('/LivePlanner/videoFromLibrary/' + eventData['video_id'])
					.then(function _receiveLibraryVideo(content) {
						$primary_container.html(content);
						$('.live-planner-contents').get(0).scrollIntoView();
						playSound();
					});
				break;
				case 'receive_video':
					if (Adzuki.LPVideo.browserSupportsZoomAudio()) {
						Adzuki.CustomConfirm({
							title  : 'Decision Time',
							content: eventData['agent_name'] + ' is requesting to start video for this consultation. Would you like to continue?',
							confirm: function confirm() {
								var client_id = eventData['client_id'];
								var url       = '/LivePlanner/videoCall/' + client_id;

								lp_video_window = window.open(
									Adzuki.base_uri + url,
									'lp_video_window',
									'popup=1,width=1380,height=850'
								);

								// display button that brings the video window into the front
								$('.lp-web-switch-to-video').removeClass('hidden');
								$('.lp-web-join-video').addClass('hidden');
							},
							cancel: function cancel() {
								// send event rejecting the video call,
								Adzuki.Ajax.get('/LivePlanner/rejectVideo')
								.then(function _videoRejected(response) {
									// client rejected the video call, let's check if the meeting
									// is currently active, if so display option to join the call
									setTimeout(function _checkOngoing() {
										ongoingMeetingCheckInWebsite();
									}, 3000);
								});
							}
						});
					} else {
						Adzuki.StatusMessage('Warning', 'Your browser does not support Zoom, the most recent version of Google Chrome is recommended', 'Zoom Calls');

						// the client's browser does not support video
						// send event to the agent
						Adzuki.Ajax.get('/LivePlanner/videoNotSupported');
					}
				break;
				case 'close_video_window':
					if (lp_video_window && !lp_video_window.closed) {
						lp_video_window.close();
					}
				break;
				case 'left_video':
					// client left the meeting or the meeting has been ended
					// either way check if it's still ongoing
					$('.lp-web-switch-to-video').addClass('hidden');
					$('.lp-web-join-video').addClass('hidden');

					setTimeout(function _checkOngoing() {
						ongoingMeetingCheckInWebsite();
					}, 5000);
				break;
				default:
					console.log('2. invalid event type passed');
				break;
			}

			exclusions = [
				'receive_content',
				'receive_city',
				'receive_individual_content',
			];

			if (exclusions.includes(eventData['eventType']) === true) {
				$("html, body").animate({ scrollTop: 0 }, "slow");
			}

			return;
		};

		this.sendReceived = function sendReceived() {
			Adzuki.Ajax.get('/LivePlanner/confirmReceived/')
			.then(function _sendCruiseLine(content) {
				// nothing to do
			});
		};

		this.refreshLog = function refreshLog() {
			Adzuki.Ajax.get(Adzuki.erez_url + Adzuki.base_uri + '/LivePlanner/log/')
			.then(function _refreshLog(content) {
				$('.lp-running-log').html(content);
			});

			setInterval(
				function _callTimer() {
					adjustTimer();
				},
				1000
			);
		};

		this.setPageGuide = function setPageGuide() {
			var json_links = [],
				guide_links = '<ul class="list-group list-group-flush">';

			if ($('#page_guide').length > 0) {
				json_links = $('#page_guide').val();
			}

			if (json_links.length > 0) {
				$.each(JSON.parse(json_links), function _iterateLinks(index, element) {
					guide_links += '<li class="list-group-item lp-page-guide-link" data-link="' + element['link'] + '"><i class="fas fa-fw ' + element['icon'] + '"></i> ' + element['label'] + '</li>';
				});

				guide_links += '</ul>';

				$('.lp-guide-box-links').html(guide_links);
				$('.lp-guide-text').css('display', 'block');
				$('.lp-guide-box-links').css('display', 'block');
			} else {
				$('.lp-guide-text').css('display', 'none');
				$('.lp-guide-box-links').css('display', 'none');
			}

			if (screen.height < screen_min_height) {
				$('.lp-guide-box-links').css('display', 'none');
				$('.lp-guide-text-right').html('<i class="fas fa-plus-circle"></i> Expand');
			}
		};

		this.showAllTravelTypes = function showAllTravelTypes() {
			$primary_container.html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading Travel Types');

			Adzuki.Ajax.get('/LivePlanner/showAllTravelTypes/')
			.then(function _showTravelTypes(content) {
				$primary_container.html(content);

				Adzuki.Form.initAjaxForm('LivePlannerProcessor');

				self.setPageGuide();
				// self.refreshLog();

				$primary_container.on('click', '.send-travel-type', function _sendType(e) {
					self.showTravelType($(this).data('type'));
				});

				self.setGettingStartedModal();
			});
		};

		this.showTravelType = function showTravelType(type) {
			$primary_container.html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading ' + type + ' suppliers...');

			Adzuki.Ajax.get('/LivePlanner/sendType/' + type)
			.then(function _sendType(content) {
				$primary_container.html(content);

				Adzuki.Form.initAjaxForm('LivePlannerProcessor');

				self.setPageGuide();
				// self.refreshLog();
			});
		};

		this.setGettingStartedModal = function setGettingStartedModal() {
			var $modal = $('#modalWindow');

			// open modal on how to get started
			$('.lp-get-started').click(function _onClick(e) {
				e.preventDefault();

				$modal.find('.modal-title').text($(this).data('title'));

				Adzuki.Ajax.get('/LivePlanner/getBrowserInfo')
				.then(function _getBrowserInfo(response) {
					$modal.find('.modal-body').html(response);
					$modal.modal('show');
				});
			});
		};

		// --- Private functions ---
		function showSailings(start_date, end_date, cruise_line_id) {
			var url = '/LivePlanner/sailings/' + cruise_line_id + '/' + start_date + '/' + end_date;

			Adzuki.Ajax.get(url)
			.then(function _showSailings(content) {
				$primary_container.html(content);

				Adzuki.Form.initAjaxForm('LivePlannerProcessor');
				$("html, body").animate({ scrollTop: 0 }, "slow");
			});
		}

		function adjustTimer() {
			var initial_time = $('.session-time').data('start'),
				current_time = moment().unix(),
				date         = new Date(null);

			if (initial_time) {
				date.setSeconds(current_time - initial_time);

				$('.session-time').html(date.toISOString().substr(11, 8));
			}
		}

		function filterResorts(attributes_arrays)
		{
			var property_id,
				matched_text,
				matched_count = 0;

			// reset global vars
			criteria_count = 0;
			resort_ids     = [];

			$('.lp-property').addClass('hidden');

			// initialize all itineraries with criteria count being 0
			$(".lp-property").each(function seedItins() {
				if ($(this).data('property-id') !== 'undefined') {
					resort_ids[$(this).data('property-id')] = 0;
				}
			});

			// loop through selected filters to determine resorts
			$.each(attributes_arrays, function _name(key, values) {
				if (key === 'length' || key === 'ship' || key === 'port') {
					return;
				}

				if (values.length > 0) {
					if (key !== 'amenity') {
						criteria_count++;
					}

					$.each(values, function _data(data_key, data_value) {
						if (data_value !== '') {
							if (key === 'amenity') {
								// amenities are stored as an array, so we have to loop through all properties
								// and compare current amenity value to see if in property's amenities
								// each amenity has to be treated as a criteria
								criteria_count++;

								$(".lp-property").each(function propertyAmenities() {
									property_id = $(this).data('property-id');

									$.each($(this).data('amenities'), function _iterateAmenities(index, amenity) {
										if (amenity === data_value) {
											resort_ids[property_id]++;
										}
									});
								});
							} else {
								find_criteria = '[data-' + key + '="' + data_value + '"]';

								$('.lp-properties').find(find_criteria).each(function checkCriteria() {
									resort_ids[$(this).data('property-id')]++;
								});
							}
						}
					});
				}
			});

			// no criteria has been selected, show all resorts
			if (criteria_count === 0) {
				$('.lp-property').removeClass('hidden');
			} else {
				// we have criteria selected
				// loop through resort ids and determine if we should show it
				$.each(resort_ids, function toggleSailing(resort_id, match_count) {
					if (match_count === criteria_count) {
						// resort matches number of criteria selected
						$('#' + resort_id).removeClass('hidden');
					}
				});
			}

			// update results header
			matched_count = $('.lp-property').not('.hidden').length;
			matched_text  = matched_count + ' Resort';

			if (matched_count !== 1) {
				matched_text += 's';
			}

			matched_text += ' Available';

			$('.lp-result-count').html(matched_text);

			// no resorts are being displayed, show no results message
			if ($(".lp-property").not(".hidden").length === 0) {
				$('.no-prop').removeClass('hidden');
			} else {
				$('.no-prop').addClass('hidden');
			}
		}

		function filterSailings(attributes_arrays)
		{
			var matched_text,
				matched_count = 0;

			// reset global vars
			criteria_count = 0;
			itinerary_ids  = [];

			$('.lp-sailing').addClass('hidden');

			// initialize all itineraries with criteria count being 0
			$(".lp-sailing").each(function seedItins() {
				itinerary_ids[$(this).data('itinerary')] = 0;
			});

			// loop through selected filters to determine sailings
			$.each(attributes_arrays, function _name(key, values) {
				if (key === 'amenity') {
					return;
				}

				if (values.length > 0) {
					criteria_count++;

					$.each(values, function _data(data_key, data_value) {
						if (data_value !== '') {
							find_criteria = '[data-' + key + '="' + data_value + '"]';

							$('.lp-sailings').find(find_criteria).each(function checkCriteria() {
								itinerary_ids[$(this).data('itinerary')]++;
							});
						}
					});
				}
			});

			// no criteria has been selected, show all sailings
			if (criteria_count === 0) {
				$('.lp-sailing').removeClass('hidden');
			} else {
				// we have criteria selected
				// loop through itinerary ids and determine if we should show it
				$.each(itinerary_ids, function toggleSailing(itinerary_id, match_count) {
					if (match_count === criteria_count) {
						// sailing matches number of criteria selected
						$('#' + itinerary_id).removeClass('hidden');
					}
				});
			}

			// update results header
			matched_count = $('.lp-sailing').not('.hidden').length;
			matched_text  = matched_count + ' Sailing';

			if (matched_count !== 1) {
				matched_text += 's';
			}

			matched_text += ' Available';

			$('.lp-result-count').html(matched_text);

			// no sailings are being displayed, show no results message
			if ($(".lp-sailing").not(".hidden").length === 0) {
				$('.no-sail').removeClass('hidden');
			} else {
				$('.no-sail').addClass('hidden');
			}
		}

		function checkIfFiltered(type)
		{
			var filtered = false;

			if (type === 'sailing') {
				$('.lp-sailing').each(function _goThroughSailings() {
					if ($(this).hasClass('hidden')) {
						filtered = true;
					}
				});
			} else if (type === 'property') {
				$('.lp-property').each(function _goThroughProperties() {
					if ($(this).hasClass('hidden')) {
						filtered = true;
					}
				});
			}

			if (filtered === true) {
				$('.lp-filter-remove').removeClass('hidden');
			} else {
				$('.lp-filter-remove').addClass('hidden');
			}

			return filtered;
		}

		function cityWeather($obj, lat, lng, date)
		{
			Adzuki.Ajax.get('/LivePlanner/weather/' + lat + '/' + lng + '/' + date)
			.then(function success(content) {
				$obj.html(content);
			});
		}

		function loadExcursions(itinerary_id) 
		{
			$('.lp-excursions').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading excursions...');

			Adzuki.Ajax.get('/LivePlanner/shoreExcursions/' + itinerary_id)
			.then(function _selectSailing(content) {
				$('.lp-excursions').html(content);
			});
		}

		function openQuickQuote($obj)
		{
			var itinerary_id = $obj.data('itinerary-id'),
				$modal       = $('#modalWindow');

			category_codes = [];

			$('.lp-extra-action').each(function _count() { 
				if ($(this).data('state') === 'selected') {
					category_codes.push($(this).data('value'));
				}
			});

			if (category_codes.length > 0) {
				Adzuki.Ajax.post(
					'/LivePlanner/quickQuote/',
					{
						itinerary_id  : itinerary_id,
						category_codes: category_codes.join()
					}
				)
				.then(function success(content) {
					$modal.find('.modal-title').text("Quick Quote");
					$(".modal-dialog").addClass('modal-lg');
					$modal.find('.modal-body').html(content);

					Adzuki.Form.initAjaxForm('LivePlannerQuickQuote');

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			}
		}

		function saveNote($obj, log_id, note, location)
		{
			var $note_field = $obj.parent().prev();

			if (location === 'expanded') {
				$note_field = $obj.prev();
			}

			if ($note_field.val().length > note_length) {
				Adzuki.StatusMessage(null, 'The length of your note exceeded <b>' + note_length + '</b> characters which is the max for a note. Please adjust.', 'Note too long');
			} else if (note.length === 0) {
				Adzuki.StatusMessage('Error', 'You must enter something in order to save the note.');
			} else {
				Adzuki.Ajax.get('/LivePlanner/saveLogNote/' + log_id + '/' + escape(note))
				.then(function _saveNote(content) {
					// self.refreshLog();
				});
			}
		}

		function selectSailing(itinerary_id) 
		{
			Adzuki.Ajax.get('/LivePlanner/sailing/' + itinerary_id)
			.then(function _selectSailing(content) {
				$primary_container.html(content);

				Adzuki.Form.initAjaxForm('LivePlannerProcessor');
				Adzuki.Buckets.initAddButton($primary_container.find('.bucket-addto'));

				loadExcursions(itinerary_id);
				$('#lp-guide-box-container').css('display', 'block');

				$('.lp-day-weather').each(function _getWeather() {
					cityWeather(
						$(this),
						$(this).data('lat'),
						$(this).data('lng'),
						$(this).data('date')
					);
				});

				self.setPageGuide();
				// self.refreshLog();
			});
		}

		function showCruiseLine(cruise_line_id) {
			$primary_container.html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading sailings...');
			Adzuki.Ajax.get('/LivePlanner/sailings/' + cruise_line_id)
			.then(function _backToSailings(content) {
				$primary_container.html(content);

				Adzuki.Form.initAjaxForm('LivePlannerProcessor');

				self.setPageGuide();
				// self.refreshLog();
			});
		}

		function summaryScrollRight($obj) {
			var current = $($obj).data('sequence'),
				next    = parseInt(current) + 1;

			$('.live-planner-summary-content').each(function _iteratePanel() {
				if ($(this).data('sequence') === current) {
					$(this).animate(
						{
							left: parseInt('-' + summary_page_width) * current
						}
					);
				}

				if ($(this).data('sequence') === next) {
					$(this).animate(
						{
							left: parseInt('-' + summary_page_width) * current
						}
					);
				}
			});
		}

		function summaryScrollLeft($obj) {
			var current = $($obj).data('sequence'),
				prev    = parseInt(current) - 1;

			$('.live-planner-summary-content').each(function _iteratePanel() {
				if ($(this).data('sequence') === current) {
					$(this).animate(
						{
							left: parseInt(summary_page_width) + parseInt($(this).css('left'))
						}
					);
				}

				if ($(this).data('sequence') === prev) {
					$(this).animate(
						{
							left: parseInt(summary_page_width) + parseInt($(this).css('left'))
						}
					);
				}
			});
		}

		function showAipPhotoGallery(property_id) {
			var property_gallery = null;

			Adzuki.Ajax.post('/AllInclusiveProperties/galleryImages/' + property_id)
			.then(function sucess(response) {
				var images         = response;
				var gallery_images = [];

				if (images.length === 0) {
					return;
				}

				$.each(images, function onEachImage(i, image) {
					gallery_images.push({
						src    : image.src,
						thumb  : image.thumb,
						subHtml: image.subHtml,
					});
				});

				property_gallery = lightGallery($('.lp-ais-image')[0], {
					licenseKey       : 'github',
					download         : false,
					plugins          : [lgThumbnail],
					dynamic          : true,
					thumbnail        : true,
					toggleThumb      : true,
					allowMediaOverlap: true,
					dynamicEl        : gallery_images,
				});

				property_gallery.openGallery();
			});
		}

		function toastMessage(message)
		{
			toastr.success(
				null,
				message,
				{
					positionClass  : 'toast-top-center',
					timeOut        : 3000,
					extendedTimeOut: 0,
				}
			);
		}

		function webWeather()
		{
			$('.lp-day-weather').each(function _getWeather() {
				cityWeather(
					$(this), 
					$(this).data('lat'), 
					$(this).data('lng'), 
					$(this).data('date')
				);
			});
		}

		// BOUND FUNCTIONS

		// CP MAXX FUNCTIONS -------------- ||
		Adzuki.onload(['/LivePlanner/session'], function onload()
		{
			var zoom_support = Adzuki.LPVideo.browserSupportsZoomVideo();

			if (screen.height < screen_min_height) {
				Cookies.set('lp_page_guide_display', 'closed');
			}

			if (screen.width < screen_min_width || screen.height < screen_min_height) {
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'For session optimization we recommend that Full Screen mode is enabled for your CP Maxx browser. Would you like to enable?',
					confirm: function confirm() {
						$('.lp-session-full-screen').trigger('click');
					}
				});
			}

			// try to prevent the agent from closing/leaving the session page
			$(window).on('beforeunload', function _onBeforeUnload() {
				if (redirect_warning) {
					return 'You are attempting to navigate away while in a session. Doing so will force you to restart from the beginning of the session. Are you sure you want to continue?';
				}
			});

			// end video if the agent leaves the page
			$(window).on('pagehide', function _onPageHide(e) {
				if ($('.lp-start-video').hasClass('hidden')) {
					$('.lp-end-video').trigger('click', true);
				}
			});

			// check if there is an ongoing meeting if so, show the button to end the call
			Adzuki.Ajax.post('/LivePlanner/ongoingMeeting')
			.then(function ongoingMeeting(response) {
				var $start_btn = $('.lp-start-video');
				var $end_btn   = $('.lp-end-video');

				if (response.error) {
					return;
				}

				$start_btn.data('started', 1);
				$end_btn.data('ended', 0);

				$start_btn.addClass('hidden');
				$end_btn.removeClass('hidden');
				$('.lp-switch-video-row').removeClass('hidden');
			});

			$primary_container.on('click', '.lp-collection-item-extra-video', function _showContentDetail(e) {
				var $modal      = $('#modalWindow'),
				    description = $(this).data('description'),
				    name        = $(this).data('name'),
				    embed_code  = $(this).data('embed-code'),
				    content     = '';

				e.preventDefault();

				if (embed_code) {
					content += '<div class="embed-responsive embed-responsive-16by9">' + $(this).data('embed-code') + '</div>';
				} else if (description) {
					content += description;
				}

				$modal.find('.modal-title').text(name);
				$modal.find('.modal-body').html(content);

                $modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
                }).modal('show');
			});

			// GENERAL FUNCTIONS -----------------------------------]
			self.showAllTravelTypes();

			$primary_container.on('click', '.btn', function _animateButton(e) {
				var obj = $(this);
				obj.addClass('lp-active-btn');

				setTimeout(function _removeAnimation () {
					obj.removeClass('lp-active-btn');
				}, 500);
			});

			// hide the start video button if the agent's browser is not supported
			if (!zoom_support) {
				$('.lp-start-video').parent().addClass('hidden');
			}

			$('body').addClass('lp-session');
			
			$('.lp-back-to-travel-types').on('click', function _sendType(e) {
				e.preventDefault();

				self.showAllTravelTypes();
			});

			$primary_container.on('click', '.lp-back-to-travel-types', function _sendType(e) {
				e.preventDefault();

				self.showAllTravelTypes();
			});

			$('.lp-running-log').on('click', '.send-travel-type', function _sendType(e) {
				self.showTravelType($(this).data('type'));
			});

			$('.lp-running-log').on('click', '.lp-no-click', function _noClickAlert(e) {
				e.stopPropagation();

				Adzuki.StatusMessage(null, 'This item is just something viewed by the client and has no action', 'No action');
			});

			$('.lp-session-log').click(function _showLog(e) {
				var $modal = $('#modalWindow');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/log/')
				.then(function _backToSailings(content) {
					$modal.find('.modal-title').text("Session Log");
					$modal.find('.modal-body').html(content);

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			$('.lp-session-full-screen').click(function _fullScreen(e) {
				e.preventDefault();

				if ($(this).data('state') === 'normal') {
					$('.navbar').addClass('hidden');
					$('.sidebar').addClass('hidden');
					$('.breadcrumb-container').addClass('hidden');
					$('main').css('margin-top', '0px');

					$(this).data('state', 'full');

					toggleFullscreen(e);
					$(this).html('<i class="fas fa-fw fa-compress"></i> Exit Full Screen</a>');
				} else {
					$('.navbar').removeClass('hidden');
					$('.sidebar').removeClass('hidden');
					$('.breadcrumb-container').removeClass('hidden');
					$('main').css('margin-top', '51px');

					$(this).data('state', 'normal');
					toggleFullscreen(e);
					$(this).html('<i class="fas fa-fw fa-expand"></i> Full Screen</a>');
				}
			});

			$('.lp-collapse-all').click(function _collapseAll(e) {
				e.preventDefault();

				$('.lp-toggle-section').each(function _checkForToggle() {
					if ($(this).data('state') === 'open') {
						$(this).trigger('click');
					}
				});

				$('.lp-toggle-extra').each(function _checkForToggle() {
					if ($(this).data('state') === 'open') {
						$(this).trigger('click');
					}
				});

				$('.lp-toggle-excursions').each(function _checkForToggle() {
					if ($(this).data('state') === 'open') {
						$(this).trigger('click');
					}
				});
			});

			$('.lp-expand-all').click(function _expandAll(e) {
				e.preventDefault();

				$('.lp-toggle-section').each(function _checkForToggle() {
					if ($(this).data('state') === 'closed') {
						$(this).trigger('click');
					}
				});

				$('.lp-toggle-extra').each(function _checkForToggle() {
					if ($(this).data('state') === 'closed') {
						$(this).trigger('click');
					}
				});

				$('.lp-toggle-excursions').each(function _checkForToggle() {
					if ($(this).data('state') === 'closed') {
						$(this).trigger('click');
					}
				});
			});

			$('.lp-session-end').on('click', function _endSession(e, override_prompt) {
				e.preventDefault();

				if (!override_prompt) {
					Adzuki.CustomConfirm({
						title  : 'Decision Time',
						content: 'Ready to end the session?',
						confirm: function confirm() {
							endSessionAndVideo();
						}
					});

					return;
				}

				endSessionAndVideo();
			});

			$('.lp-session-resume').on('click', function _resumeSession(e) {
				e.preventDefault();

				// open modal to either send "resume" message or designate new primary client
				if (group_session) {
					Adzuki.Ajax.get('/LivePlanner/newPrimaryClient/1')
					.then(function _newPrimaryClient(response) {
						var $modal = $('#modalWindow');

						$modal.find('.modal-title').text('Resume Session');
						$modal.find('.modal-body').html(response);
						$modal.modal('show');

						Adzuki.Form.initAjaxForm('LivePlannerNewPrimaryClient');
					});

					return;
				}

				Adzuki.Ajax.get('/LivePlanner/resume/')
				.then(function _resume(response) {
					// nothing to do
				});
			});

			$('.lp-start-video').on('click', function _startVideo(e, begin_video) {
				var $self     = $(this);
				var $end_btn  = $('.lp-end-video');
				var client_id = $self.data('client-id');
				var url       = '/LivePlanner/sendVideo';

				e.preventDefault();

				if (begin_video) {
					url += '/1';
				}

				// send message that the agent wants to start a video session
				Adzuki.Ajax.get(url).then(function _sendVideo(response) {
					var url = '/LivePlanner/videoCall/' + client_id;

					// check if there was a problem starting video
					if (response.error) {
						Adzuki.StatusMessage('Error', response.error);
						return;
					}

					// open the video window
					lp_video_window = window.open(
						Adzuki.base_uri + url,
						'lp_video_window',
						'popup=1,width=1380,height=850'
					);

					$self.find('span').first().text('Starting video call...');
					$self.data('started', 1);
					$end_btn.data('ended', 0);

					// hide the start button and display buttons to end video
					// and to bring the video window to the front
					$self.addClass('hidden');
					$self.find('span').first().text('Start Video');
					$end_btn.removeClass('hidden');
					$('.lp-switch-video-row').removeClass('hidden');
				});
			});

			// bring the video window back to the front
			$('.lp-switch-to-video').on('click', function _switchToVideoWindow(e) {
				var client_id = $(this).data('client-id');
				var url       = '/LivePlanner/videoCall/' + client_id;

				e.preventDefault();

				if (lp_video_window && !lp_video_window.closed) {
					lp_video_window.focus();
				} else {
					// we lost the reference to the window (most likely due to a refresh)
					// try to get the window back since it should be there
					Cookies.set('lp_confirm_video_close', 0);

					lp_video_window = window.open(
						Adzuki.base_uri + url,
						'lp_video_window',
						'popup=1,width=1380,height=850'
					);

					lp_video_window.focus();
				}
			});

			$('.lp-end-video').on('click', function _endAgentVideo(e, override_prompt) {
				var $self = $(this);

				e.preventDefault();

				if (!override_prompt) {
					Adzuki.Ajax.post('/LivePlanner/sessionVideoStatus')
					.then(function _sessionVideoStatus(response) {
						if (response.error) {
							Adzuki.StatusMessage('error', response.error);
							return;
						}

						if (parseInt(response.begin_video) === 1) {
							// video was started at the beginning
							Adzuki.CustomConfirm({
								title  : 'Decision Time',
								content: 'Clicking this option will end both video and the session for you and your client(s). Would you like to continue?',
								confirm: function _confirm() {
									$('.lp-session-end').trigger('click', true);
								}
							});
						} else {
							// video was started at some other point
							Adzuki.CustomConfirm({
								title  : 'Decision Time',
								content: 'Clicking this option will only end video for you and your client(s) and the session will remain active. Would you like to continue?',
								confirm: function _confirm() {
									endAgentVideo($self);
								}
							});
						}
					});

					return;
				}

				endAgentVideo($self);
			});

			$('.lp-running-log').on('click', '.lp-session-log-entry', function _triggerEntry(e) {
				var entry_id = $(this).data('log-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/logEntry/' + entry_id)
				.then(function _triggerEntry(content) {
					toastMessage('Item Resent');
					playSound();
				});
			});

			$('.lp-running-log').on('click', '.lp-item-add-bucket', function _addToBucket(e) {
				e.preventDefault();
				e.stopPropagation();

				Adzuki.Ajax.post(
					'/LivePlanner/addToBucket/',
					{
						image      : $(this).data('image'),
						title      : $(this).data('title'),
						description: $(this).data('description'),
						supplier   : $(this).data('supplier'),
						item_id    : $(this).data('item-id'),
						item_type  : $(this).data('item-type'),
						log_id     : $(this).data('log-id'),
					}
				).then(function success(content) {
					if (content.saved === 'true') {
						Adzuki.StatusMessage('success', 'Item added to your LivePlanner bucket');
					} else {
						Adzuki.StatusMessage('error', 'Item already exists in your LivePlanner Bucket');
					}
				});
			});

			$primary_container.on('click', '.send-travel-type', function _sendType(e) {
				e.preventDefault();

				self.showTravelType($(this).data('type'));
			});

			$primary_container.on('click', '.lp-important-link', function _sendLink(e) {
				var link     = $(this).data('link');
				var name     = $(this).data('name');
				var link_url = '/LivePlanner/sendLink/';

				e.preventDefault();

				link_url += encodeURIComponent(link);
				link_url += '/' + encodeURIComponent(name);

				// open modal and ask if we are in a group session
				if (group_session) {
					Adzuki.CustomConfirm({
						title            : 'Important Link',
						content          : 'Who should receive this link?',
						close_icon       : true,
						backgroundDismiss: true,
						confirm_btn_text : 'Primary Client',
						cancel_btn_text  : 'All Participants',
						confirm          : function confirm() {
							// send link only to primary client
							Adzuki.Ajax.get(link_url).then(function _sendLink(content) {
								toastMessage('Important Link Sent');
								playSound();
								// self.refreshLog();
							});
						},
						cancel: function cancel() {
							// send link only to group of clients
							link_url += '/1';
							Adzuki.Ajax.get(link_url).then(function _sendLink(content) {
								toastMessage('Important Link Sent');
								playSound();
								// self.refreshLog();
							});
						}
					});

					return;
				}

				Adzuki.Ajax.get(link_url).then(function _sendLink(content) {
					toastMessage('Important Link Sent');
					playSound();
					// self.refreshLog();
				});
			});

			$('#modalWindow').on('click', '.view-collections', function _viewCollections(e) {
				var collection_supplier_id = $(this).data('collection-supplier-id');

				e.stopPropagation();
				e.stopImmediatePropagation();
				e.preventDefault();

				$('.modal').modal('hide');

				Adzuki.Ajax.get('/LivePlanner/collection/' + collection_supplier_id)
				.then(function _selectCollectionSuppliers(content) {
					$primary_container.html(content);
					// self.refreshLog();
				});
			});

			$('#modalWindow').on('click', '.lp-basic-link', function _sendBasicLink(e) {
				var link  = $(this).data('link'),
					name  = $(this).data('name'),
					$self = $(this);

				e.preventDefault();

				$self.text('Sending...');

				Adzuki.Ajax.get('/LivePlanner/sendLink/' + encodeURIComponent(link) + '/' + escape(name))
				.then(function _sendLink(content) {
					toastMessage('Link Sent');
					playSound();
					$self.text('Send Link');
					// self.refreshLog();
				});
			});

			$('#modalWindow').on('change', '.microsite-category', function _filterMicrosites() {
				showSignatureMicrosites($(this).val());
			});

			$('.lp-running-log').on('click', '.lp-save-note', function _save3813Note(e) {
				var $self  = $(this),
					log_id = $(this).data('log-id'),
					note   = $(this).parent().prev().val();

				e.preventDefault();

				saveNote($self, log_id, note, '');
			});

			$('.lp-running-log').on('keypress', '.lp-note', function _saveNoteViaEnter(e) {
				var keycode = (e.keyCode ? e.keyCode : e.which),
					$link   = $(this).next().find('.lp-save-note');

				if (keycode === 13) {
					if ($('.lp-note').val().length > note_length) {
						Adzuki.StatusMessage(null, 'The length of your note exceeded <b>' + note_length + '</b> characters which is the max for a note. Please adjust.', 'Note too long');
					} else {
						$link.trigger('click');
					}
				}
			});

			$('#lp-guide-box-container .lp-guide-text').click(function _expandGuideBox() {
				if ($('.lp-guide-box-links').css('display') === 'none') { // open
					$('.lp-guide-box-links').css('display', 'block');
					$('.lp-guide-text-right').html('<i class="fas fa-minus-circle"></i> Collapse');

					Cookies.set('lp_page_guide_display', 'open', {
						path: '/'
					});
				} else { // close
					$('.lp-guide-box-links').css('display', 'none');
					$('.lp-guide-text-right').html('<i class="fas fa-plus-circle"></i> Expand');

					Cookies.set('lp_page_guide_display', 'closed', {
						path: '/'
					});
				}
			});

			// open the session log
			$('.lp-expand-log').on('click', function _expandLog(e) {
				var $modal = $('#modalWindow');
				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/expandedLog/')
				.then(function success(content) {
					$modal.find('.modal-title').text("Session Log");
					$modal.find('.modal-body').html(content);

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			// open modal to view session participants
			$('.lp-session-participants').off().on('click', function _viewParticipants(e) {

				e.preventDefault();

				openParticipantsModal();
			});

			$primary_container.on('click', '.lp-client-recap', function _showClientRecap(e) {
				var $modal    = $('#modalWindow'),
					client_id = $(this).data('client-id');
				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/recap/' + client_id)
				.then(function success(content) {
					$modal.find('.modal-title').text("Client Recap");
					$(".modal-dialog").addClass('modal-lg');
					$modal.find('.modal-body').html(content);

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			$primary_container.on('click', '.result-special-sale-details', function _showSpecialSaleDetails(e) {
				var special_sale_id = $(this).data("special-sale-id"),
					$modal          = $(".modal");

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading Special Sale Details...');

				Adzuki.Ajax.get('/Offers/detail/' + special_sale_id)
				.then(function success(html) {
					$modal.find('.modal-body').html(html);
					$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text('Special Sale Details');
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			// self.refreshLog();

			// CRUISE FUNCTIONS -----------------------------------]
			$primary_container.on('click', '.lp-cruise-line', function _selectCruiseLine(e) {
				e.preventDefault();
				showCruiseLine($(this).data('id'));
			});

			$('.lp-running-log').on('click', '.lp-cruise-line', function _selectCruiseLine(e) {
				e.preventDefault();
				showCruiseLine($(this).data('id'));
			});

			$primary_container.on('click', '.lp-sailing', function _selectSailing(e) {
				var itinerary_id = $(this).data('itinerary');

				selectSailing(itinerary_id);
			});

			$('.lp-running-log').on('click', '.lp-sailing', function _selectSailing(e) {
				var itinerary_id = $(this).data('itinerary');

				selectSailing(itinerary_id);
			});

			$primary_container.on('click', '.lp-back-sailings', function _backToSailings(e) {
				var cruise_line_id = $(this).data('cruise-line-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sailings/' + cruise_line_id)
				.then(function _backToSailings(content) {
					$primary_container.html(content);

					Adzuki.Form.initAjaxForm('LivePlannerProcessor');

					self.setPageGuide();
					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-toggle-extra', function _toggleSection(e) {
				var section = $(this).data('section');

				if ($(this).data('state') === 'open') {
					$(this).data('state', 'closed');
					$(this).html('<i class="adzicon-collapse far fa-fw fa-plus-square"></i>');

					$('.lp-extras[data-section="' + section + '"]').addClass('hidden');
					$('.lp-collection-item-contents[data-section="' + section + '"]').addClass('hidden');
				} else {
					$(this).data('state', 'open');
					$(this).html('<i class="adzicon-collapse far fa-fw fa-minus-square"></i>');

					$('.lp-extras[data-section="' + section + '"]').removeClass('hidden');
					$('.lp-collection-item-contents[data-section="' + section + '"]').removeClass('hidden');
				}
			});

			$primary_container.on('click', '.lp-toggle-section', function _toggleSection(e) {
				var section = $(this).data('section');

				if ($(this).data('state') === 'open') {
					$(this).data('state', 'closed');
					$(this).html('<i class="adzicon-collapse far fa-fw fa-plus-square"></i>');

					$('.lp-sections[data-section="' + section + '"]').addClass('hidden');
				} else {
					$(this).data('state', 'open');
					$(this).html('<i class="adzicon-collapse far fa-fw fa-minus-square"></i>');

					$('.lp-sections[data-section="' + section + '"]').removeClass('hidden');
				}
			});

			$primary_container.on('click', '.lp-toggle-excursions', function _toggleExcursions(e) {
				if ($(this).data('state') === 'open') {
					$(this).data('state', 'closed');
					$(this).html('<i class="adzicon-collapse far fa-fw fa-plus-square"></i>');

					$('.lp-excursions').addClass('hidden');
				} else {
					$(this).data('state', 'open');
					$(this).html('<i class="adzicon-collapse far fa-fw fa-minus-square"></i>');

					$('.lp-excursions').removeClass('hidden');
				}
			});

			$primary_container.on('click', '.lp-extra', function _sendIndividualContent(e) {
				var name         = $(this).data('name'),
					id           = $(this).data('id'),
					itinerary_id = $(this).data('itinerary-id');

				e.preventDefault();

				if (actively_sending) {
					Adzuki.StatusMessage('error', 'Please wait until the last item you clicked has finished being sent');
				} else {
					$(this).addClass('lp-extra-loader-active');

					actively_sending = true;

					if (!$(this).hasClass('lp-property-photo')) {
						Adzuki.Ajax.get('/LivePlanner/sendIndividualContent/' + name + '/' + id + '/' + itinerary_id)
						.then(function _sendIndividualContent(content) {
							toastMessage('Item Sent');
							playSound();

							// self.refreshLog();
						});
					}
				}
			});

			$primary_container.on('click', '.lp-content', function _sendContent(e) {
				var content_type     = $(this).data('content-type'),
					external_ship_id = $(this).data('external-ship-id'),
					itinerary_id     = $('#itinerary-id').val();

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendContent/' + external_ship_id + '/' + content_type + '/' + itinerary_id)
				.then(function _sendContent(content) {
					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-city', function _sendCity(e) {
				var city_id       = $(this).data('city-id'),
					itinerary_id  = $('#itinerary-id').val();

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendCity/' + city_id + '/' + itinerary_id)
				.then(function _sendCity(content) {
					toastMessage('City Details Sent');
					playSound();
					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-cruisetour', function _sendCruisetour(e) {
				var cruisetour_id = $(this).data('cruisetour-id'),
					itinerary_id  = $('#itinerary-id').val();

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendCruisetour/' + cruisetour_id + '/' + itinerary_id)
				.then(function _sendCruisetour(content) {
					toastMessage('Cruisetour Details Sent');
					playSound();
					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-send-pricing', function _sendPricing(e) {
				var itinerary_id = $(this).data('itinerary-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPricing/' + itinerary_id)
				.then(function _sendPricing(content) {
					toastMessage('Pricing Sent');
					playSound();
				});
			});

			$primary_container.on('click', '.lp-send-custom-pricing', function _sendCustomPricing(e) {
				var itinerary_id = $(this).data('itinerary-id'),
					$modal       = $('#modalWindow');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/customPricing/'+ itinerary_id)
				.then(function success(content) {
					$modal.find('.modal-title').text("Custom Pricing");
					$(".modal-dialog").addClass('modal-lg');
					$modal.find('.modal-body').html(content);

					Adzuki.Form.initAjaxForm('LivePlannerCustomPricing');

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			$primary_container.on('click', '.lp-offer-link', function _showOfferDetails(e) {
				var offer_id = $(this).data('offer-id'),
					$modal   = $('#modalWindow'),
					body;

				e.preventDefault();
				$(".modal-dialog").addClass('modal-lg');

				Adzuki.Ajax.get('/Offers/getDescription/' + offer_id)
				.then(function _backToSailings(content) {
					body = '<p><img src="' + Adzuki.base_uri + content.logo + '"></p>';
					body += content.body;

					$modal.find('.modal-title').text(content.vendor_name + ' - ' + content.offer_name);
					$modal.find('.modal-body').html(body);

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			$primary_container.on('click', '.lp-offer-comment', function _showOfferCommentBox(e) {
				var offer_id = $(this).data('offer-id');

				e.preventDefault();

				if ($(this).html() === '<i class="adzicon-add fas fa-fw fa-plus-circle"></i> Add comments') {
					$('.lp-offer-comment-box').filter('[data-offer-id="' + offer_id + '"]').show();
					$(this).html('<i class="adzicon-add fas fa-fw fa-minus-circle"></i> Remove comments');
				} else {
					$('#offer_comment').val('');
					$('.lp-offer-comment-box').filter('[data-offer-id="' + offer_id + '"]').hide();
					$(this).html('<i class="adzicon-add fas fa-fw fa-plus-circle"></i> Add comments');
				}
			});

			$primary_container.on('click', '.lp-offer', function _sendOffer(e) {
				var offer_id     = $(this).data('offer-id'),
					itinerary_id = $(this).data('itinerary-id'),
					comment      = $('.offer-comment').filter('[data-offer-id="' + offer_id + '"]').val();

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendOffer/' + offer_id + '/' + itinerary_id + '/' + escape(comment))
				.then(function _sendOffer(content) {
					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-overview-link', function _selectSailing(e) {
				var itinerary_id = $(this).data('itinerary-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendOverview/' + itinerary_id)
				.then(function _sendOverview(content) {
					toastMessage('Sailing Overview Sent');
					playSound();
					// self.refreshLog();
				});
			});

			$('#modalWindow').on('click', '.lp-save-note', function _saveNoteFromExpanded(e) {
				var $self  = $(this),
					log_id = $(this).data('log-id'),
					note   = $('.lp-note[data-log-id="' + log_id +'"]').val(),
					$modal = $('#modalWindow');
				e.preventDefault();

				saveNote($self, log_id, note, 'expanded');

				Adzuki.Ajax.get('/LivePlanner/expandedLog/')
				.then(function success(content) {
					$modal.find('.modal-title').text("Session Log");
					$modal.find('.modal-body').html(content);

					Adzuki.Form.initAjaxForm('LivePlannerLogSearch');

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			$('#modalWindow').on('click', '.lp-resend-from-log', function _triggerEntry(e) {
				var entry_id = $(this).data('log-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/logEntry/' + entry_id)
				.then(function _triggerEntry(content) {
					toastMessage('Item Resent');
					playSound();
				});
			});

			$('#modalWindow').on('click', '.lp-expanded-item-add-bucket', function _addToBucketExpanded(e) {
				e.preventDefault();

				Adzuki.Ajax.post(
					'/LivePlanner/addToBucket/',
					{
						image      : $(this).data('image'),
						title      : $(this).data('title'),
						description: $(this).data('description'),
						supplier   : $(this).data('supplier'),
						item_id    : $(this).data('item-id'),
						item_type  : $(this).data('item-type'),
						log_id     : $(this).data('log-id'),
					}
				).then(function success(content) {
					if (content.saved === 'true') {
						Adzuki.StatusMessage('success', 'Item added to your LivePlanner bucket');
					} else {
						Adzuki.StatusMessage('error', 'Item already exists in your LivePlanner Bucket');
					}
				});
			});

			$('#modalWindow').on('click', '#lp-log-search-btn', function _searchLog(e) {
				var term        = $('#liveplannerlogsearch-term').val().toLowerCase(),
					entry_found = false;

				e.preventDefault();

				if (term.length === 0) {
					Adzuki.StatusMessage('Error', 'Search term not entered.');
				} else {
					$('.lp-log-entry-encapsulator').addClass('hidden');

					$('.lp-log-entry-encapsulator').each(function _goThroughEntries() {
						if ($(this).data('title').indexOf(term) !== -1) {
							$(this).removeClass('hidden');
							entry_found  = true;
						}

						if ($(this).data('additional').indexOf(term) !== -1) {
							$(this).removeClass('hidden');
							entry_found  = true;
						}

						if ($(this).data('comment').indexOf(term) !== -1) {
							$(this).removeClass('hidden');
							entry_found  = true;
						}

						if ($(this).data('notes').indexOf(term) !== -1) {
							$(this).removeClass('hidden');
							entry_found  = true;
						}
					});

					if (entry_found === false) {
						$('#lp-search-nf').removeClass('hidden');
					} else {
						$('#lp-search-nf').addClass('hidden');
					}

					$('.lp-log-search-clear').removeClass('hidden');
				}
			});

			$('#modalWindow').on('click', '.lp-log-search-clear', function _searchLog(e) {
				e.preventDefault();

				$('.lp-log-entry-encapsulator').removeClass('hidden');
				$('#liveplannerlogsearch-term').val('');
				$(this).addClass('hidden');
			});

			$('#modalWindow').on('keypress', '#liveplannerlogsearch-term', function _runSearch(e) {
				var keycode = (e.keyCode ? e.keyCode : e.which);

				if (keycode === 13) {
					$('#lp-log-search-btn').trigger('click');
				}
			});

			// QUICK QUOTE STUFF
			$primary_container.on('click', '.lp-extra-action', function _quickQuoteSelection(e) {
				var num_selected   = 0,
					type           = $(this).data('type'),
					itinerary_id   = $(this).data('itinerary-id'),
					max_categories = 5;

				e.preventDefault();
				e.stopPropagation();

				if ($(this).data('state') === 'off') {
					$(this).addClass('lp-extra-action-active');
					$(this).data('state', 'selected');

					toastMessage('Added to Quick Quote');
				} else {
					$(this).removeClass('lp-extra-action-active');
					$(this).data('state', 'off');

					toastMessage('Removed from Quick Quote');
				}

				$('.lp-extra-action').each(function _count() {
					if ($(this).data('state') === 'selected') {
						num_selected++;
					}
				});

				if (num_selected > max_categories) {
					Adzuki.StatusMessage('Error', 'You may only choose up to ' + max_categories + ' categories to quote at a time.');
					$(this).removeClass('lp-extra-action-active');
					$(this).data('state', 'off');
				} else {
					if (num_selected > 0 && $('.lp-page-guide-addition').length === 0) {
						switch (type) {
							case 'quick-quote': // later we may have more types
							default:
								$('.lp-qq-btn-alt').removeClass('hidden');
								$('.lp-guide-box-links ul').append('<li class="list-group-item lp-page-guide-addition" data-link="quick_quote" data-itinerary-id="' + itinerary_id + '"><i class="fas fa-bolt"></i> Quick Quote (<span id="num-item-selected"></span>) <span class="lp-remove-qq pull-right"><i class="fas fa-times"></i></span></li>');
							break;
						}
					} else if (num_selected === 0) {
						$('.lp-qq-btn-alt').addClass('hidden');
						$('.lp-page-guide-addition').remove('');
					}

					$('#num-item-selected').text(num_selected);
				}
			});

			$('#lp-guide-box-container').on('click', '.lp-page-guide-addition', function _quickQuoteProcess(e) {
				openQuickQuote($(this));
			});

			$('#lp-guide-box-container').on('click', '.lp-remove-qq', function _clearQqCategories(e) {
				e.preventDefault();
				e.stopPropagation();

				$('.lp-extra-action').each(function _count() {
					$(this).removeClass('lp-extra-action-active');
					$(this).data('state', 'off');
				});

				$('.lp-qq-btn-alt').addClass('hidden');
				$('.lp-page-guide-addition').remove('');
			});

			$('#modalWindow').on('click', '.lp-rate-code-btn', function _fetchRateCodes(e) {
				var category_codes = [];

				$('.lp-category-code-check').each(function _getSelectedCodes(e) {
					if ($(this).prop('checked') === true) {
						category_codes.push($(this).val());
					}
				});

				if ($('#liveplannerquickquote-adults').val() === '0' && $('#liveplannerquickquote-seniors').val() === '0') {
					Adzuki.StatusMessage('Error', 'At least 1 adult or senior is required.');
				} else if ($('#liveplannerquickquote-passenger_city').val() === '') {
					Adzuki.StatusMessage('Error', 'Passenger city is required.');
				} else {
					let child_field_error  = false;
					if ($('#liveplannerquickquote-children').val() !== 0) { // eslint-disable-line no-negated-condition
						let children_count = $('#liveplannerquickquote-children').val();
						for (let child = 0; child < children_count; child++) {
							if ($('#liveplannerquickquote-children_ages-'+ child).val() === '') {
								child_field_error = true;
							}
						}
						if (child_field_error) {
							Adzuki.StatusMessage('Error', 'Child age is required.');
						}
					}
					if (!child_field_error) {
						if (category_codes.length > 0) { // eslint-disable-line no-lonely-if
							$('.lp-rate-codes').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Fetching rate codes...');
							$('.lp-toggle-pax-makeup').data('state', 'closed');
							$('.lp-toggle-pax-makeup').html('<i class="adzicon-collapse far fa-fw fa-plus-square"></i>');
							$('.lp-pax-makeup').addClass('hidden');

							Adzuki.Ajax.post('/LivePlanner/rateCodes/', $('#lp-quick-quote-form').serialize()).then(function success(content) {
								$('.lp-rate-codes').html(content);
							});
						} else {
							Adzuki.StatusMessage('Error', 'Please select at least one category.');
						}
					}
				}
			});

			$('#modalWindow').on('click', '.lp-toggle-pax-makeup', function togglePaxMakeup(e) {
				if ($(this).data('state') === 'open') {
					$(this).data('state', 'closed');
					$(this).html('<i class="adzicon-collapse far fa-fw fa-plus-square"></i>');
					$('.lp-pax-makeup').addClass('hidden');
				} else {
					$(this).data('state', 'open');
					$(this).html('<i class="adzicon-collapse far fa-fw fa-minus-square"></i>');
					$('.lp-pax-makeup').removeClass('hidden');
				}
			});

			$('#modalWindow').on('click', '.lp-toggle-rate-codes', function toggleRateCodes(e) {
				if ($(this).data('state') === 'open') {
					$(this).data('state', 'closed');
					$(this).html('<i class="adzicon-collapse far fa-fw fa-plus-square"></i>');
					$('.lp-rate-codes-container').addClass('hidden');
				} else {
					$(this).data('state', 'open');
					$(this).html('<i class="adzicon-collapse far fa-fw fa-minus-square"></i>');
					$('.lp-rate-codes-container').removeClass('hidden');
				}
			});

			$('#modalWindow').on('click', '.lp-toggle-qq-pricing', function toggleQqPricing(e) {
				if ($(this).data('state') === 'open') {
					$(this).data('state', 'closed');
					$(this).html('<i class="adzicon-collapse far fa-fw fa-plus-square"></i>');
					$('.lp-qq-final-pricing-container').addClass('hidden');
				} else {
					$(this).data('state', 'open');
					$(this).html('<i class="adzicon-collapse far fa-fw fa-minus-square"></i>');
					$('.lp-qq-final-pricing-container').removeClass('hidden');
				}
			});

			$('#modalWindow').on('click', '.lp-qq-pricing-btn', function _fetchPricing(e) {
				var category_codes = [];

				if ($('input[name="rate_code"]:checked').val() === undefined || $('input[name="rate_code"]:checked').val() === '') {
					Adzuki.StatusMessage('Error', 'Please select a rate code.');
				} else {
					$('.lp-qq-pricing').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Fetching pricing...');

					$('.lp-category-code-check').each(function _getSelectedCodes(e) {
						if ($(this).prop('checked') === true) {
							category_codes.push($(this).val());
						}
					});

					// get the pricing
					Adzuki.Ajax.post('/LivePlanner/quickQuotePricing/',
						{
							rate_code     : $('input[name="rate_code"]:checked').val(),
							itinerary_id  : $('#liveplannerquickquote-itinerary_id').val(),
							category_codes: category_codes
						}
					)
					.then(function success(content) {
						$('.lp-qq-pricing').html(content);
						Adzuki.Form.initAjaxForm('LivePlannerQuickQuoteSend');
					});

					$('.lp-toggle-rate-codes').data('state', 'closed');
					$('.lp-toggle-rate-codes').html('<i class="adzicon-collapse far fa-fw fa-plus-square"></i>');
					$('.lp-rate-codes-container').addClass('hidden');
				}
			});

			$('#modalWindow').on('click', '.lp-category-code-all', function _qqCategoryCheckUncheckAll(e) {
				if ($(this).prop('checked') === true) {
					$('.lp-category-code-check').prop('checked', true);
				} else {
					$('.lp-category-code-check').prop('checked', false);
				}
			});

			$('#modalWindow').on('click', '.lp-qq-start-over', function _qqStartOver(e) {
				$('#modalWindow').modal('hide');

				$('.lp-remove-qq').trigger('click');
			});

			$primary_container.on('click', '.lp-qq-btn-alt', function _triggerQuickQuoteFromBtn(e) {
				e.preventDefault();

				openQuickQuote($('.lp-page-guide-addition'));
			});
			// END QUICK QUOTE

			$('#lp-guide-box-container').on('click', '.lp-page-guide-link', function _goToAnchor(e) {
				var aTag = $("a[name='" + $(this).data('link') + "']");

				$('html,body').animate(
					{
						scrollTop: aTag.offset().top
					},
					'fast'
				);
			});

			$('#lp-guide-box-container').on('click', '.lp-page-guide-upload', function _share(e) {
				var $modal = $('#modalWindow');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/share/')
				.then(function success(content) {
					$modal.find('.modal-title').text("Share Item With Client");
					$(".modal-dialog").addClass('modal-lg');
					$modal.find('.modal-body').html(content);

					Adzuki.Form.initAjaxForm('LivePlannerShare');

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			// LIBRARY IN A SESSION
			$('#lp-guide-box-container').on('click', '.lp-page-guide-library', function _share(e) {
				var $modal = $('#modalWindow');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sessionLibrary/')
				.then(function success(content) {
					$modal.find('.modal-title').text("LivePlanner Library");
					$(".modal-dialog").addClass('modal-lg');
					$modal.find('.modal-body').html(content);

					Adzuki.Form.initAjaxForm('LivePlannerLibrarySearch');

					showDestinationGuides();
					showSignatureMicrosites('');
					showVideoLibrary();
					showCollections();
					
					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			$('#modalWindow').on('click', '.lp-library-send', function _send(e) {
				var item_id = $(this).data('item-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendFromLibrary/' + item_id)
				.then(function _sendFromLibrary(content) {
					toastMessage('Library Item Sent');
					playSound();
				});
			});

			$('#modalWindow').on('click', '.lp-video-send', function _send(e) {
				var video_id = $(this).data('video-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendLibraryVideo/' + video_id)
				.then(function _sendVideo(content) {
					toastMessage('Video Sent');
					playSound();
				});
			});

			$('#modalWindow').on('click', '.lp-library-search', function _searchLibrary() {
				var term = $('#lp-search-term').val(),
					title,
					supplier,
					comment;

				if (term.length > 2) {
					$('.lp-library-items').each(function _hideItems() {
						$(this).addClass('hidden');
					});

					$('.lp-library-items').each(function _showItems() {
						title    = $(this).data('title').toLowerCase();
						supplier = $(this).data('supplier').toLowerCase();
						comment  = $(this).data('comment').toLowerCase();

						if (title.indexOf(term) >= 0 || supplier.indexOf(term) >= 0 || comment.indexOf(term) >= 0) {
							$(this).removeClass('hidden');
						}
					});

					$('.lp-library-clear').removeClass('hidden');
				} else {
					Adzuki.StatusMessage('Error', 'Search term is not long enough.');
				}
			});

			$('#modalWindow').on('click', '.lp-library-clear', function _clearSearch(e) {
				e.preventDefault();

				$('#lp-search-term').val('');
				$('.lp-library-items').each(function _unHideItems() {
					$(this).removeClass('hidden');
				});

				$(this).addClass('hidden');
			});

			$('#modalWindow').on('keypress', '#lp-search-term', function _executeSearch(e) {
				var keycode = (e.keyCode ? e.keyCode : e.which);

				if (keycode === 13) {
					$('.lp-library-search').trigger("click");
				}
			});
			// END LIBRARY

			// FILTERS AND BUTTONS
			$primary_container.on('click', '.lp-option-btns', function _filter(e) {
				var type      = $(this).data('type'),
					btn_class = $(this).data('class');

				e.preventDefault();

				if ($(this).data('value') !== '') {
					if ($.inArray($(this).data('value'), attributes_arrays[$(this).data('type')]) === -1) {
						attributes_arrays[$(this).data('type')].push($(this).data('value'));
					} else {
						attributes_arrays[$(this).data('type')].splice($.inArray($(this).data('value'), attributes_arrays[$(this).data('type')]), 1);
					}
				}

				// handle the buttons
				$('.lp-option-btns').each(function _handleButtons() {
					if ($(this).data('type') === type) {
						// toggle active/inactive button state based on value being in the array
						if ($.inArray($(this).data('value'), attributes_arrays[$(this).data('type')]) > -1) {
							$(this).addClass('lp-option-active');
							$(this).removeClass('lp-option-inactive');
						} else {
							$(this).removeClass('lp-option-active');
							$(this).addClass('lp-option-inactive');
						}
					}
				});

				switch (btn_class) {
					case 'cruise': // cruises
						// filter out the results based on selected attributes
						filterSailings(attributes_arrays);

						// toggle Clear Filters button
						checkIfFiltered('sailing');
						break;
					case 'ais': // all inclusives
						// filter out the results based on selected attributes
						filterResorts(attributes_arrays);

						// toggle Clear Filters button
						checkIfFiltered('property');
					break;
					default:
						console.log("undefined travel type");
					break;
				}
			});

			// check/uncheck all attribute options
			$primary_container.on('click', '.lp-options-toggle-all', function _toggleOptions(e) {
				var travel_type      = $(this).data('class'),
					attribute_type   = $(this).data('type'),
					attribute_action = $(this).data('action');

				e.preventDefault();

				$('.lp-option-btns').each(function _handleButtons() {
					if ($(this).data('type') === attribute_type) {
						if (attribute_action === 'check') {
							$(this).addClass('lp-option-active');
							$(this).removeClass('lp-option-inactive');
						} else {
							$(this).addClass('lp-option-inactive');
							$(this).removeClass('lp-option-active');
						}
					}
				});

				// clear out the attribute types values because checking/unchecking all is essentially same logic wise
				attributes_arrays[attribute_type] = [];

				// need to handle amenity check all differently from others
				if (attribute_type === 'amenity' && attribute_action === 'check') {
					// when check all is selected, we need to pass all amenity options to the array for filtering
					$('.lp-option-btns').each(function _addAmenities() {
						if ($(this).data('type') === attribute_type) {
							attributes_arrays[attribute_type].push($(this).data('value'));
						}
					});
				}

				switch (travel_type) {
					case 'cruise': // cruise
						filterSailings(attributes_arrays);
						checkIfFiltered('cruise');
						break;
					case 'ais': // all inclusives
						filterResorts(attributes_arrays);
						checkIfFiltered('property');
					break;
					default:
						console.log("undefined travel type");
					break;
				}
			});

			// toggle display of filter attribute options
			$primary_container.on('click', '.lp-filter', function _showHideFilters(e) {
				var type = $(this).data('type');

				e.preventDefault();

				if ($(this).data('state') === 'open') {
					$(this).data('state', 'closed');
					$(this).removeClass('lp-filter-active');

					$('.lp-option-container').each(function _hideSection() {
						if ($(this).data('type') === type) {
							$(this).addClass('hidden');
						}
					});
				} else {
					$(this).data('state', 'open');
					$(this).addClass('lp-filter-active');

					$('.lp-option-container').each(function _showSection() {
						if ($(this).data('type') === type) {
							$(this).removeClass('hidden');
						}
					});
				}
			});

			// clear all filters
			$primary_container.on('click', '.lp-filter-remove', function _removeFilters(e) {
				var matched_count,
					matched_text;

				e.preventDefault();

				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'Are you sure you want to remove all of your filters?',
					confirm: function confirm() {
						// reset global criteria data
						itinerary_ids     = [];
						resort_ids        = [];
						criteria_count    = 0;
						attributes_arrays = {
							length     : [],
							destination: [],
							ship       : [],
							port       : [],
							amenity    : [],
							advantage  : [],
							tours      : [],
						};

						// set all option buttons to active state
						$('.lp-option-btns').each(function _clearEm() {
							if ($(this).data('type') === 'amenity') {
								// amenity criteria is not selected by default
								$(this).addClass('lp-option-inactive');
								$(this).removeClass('lp-option-active');
							} else {
								// normal criteria is selected by default
								$(this).addClass('lp-option-active');
								$(this).removeClass('lp-option-inactive');
							}
						});

						// toggle the results based on type
						switch ($('.lp-filter-remove').data('type')) {
							case 'cruise':
								// show all sailings again
								$('.lp-sailing').removeClass('hidden');

								matched_count = $('.lp-sailing').not('.hidden').length;
								matched_text  = matched_count + ' Sailing';
								break;
							case 'ais': // all inclusives
								// show all properties again
								$('.lp-property').removeClass('hidden');

								matched_count = $('.lp-property').not('.hidden').length;
								matched_text  = matched_count + ' Resort';
							break;
							default:
								console.log("undefined travel type");
							break;
						}

						// update results header
						if (matched_count !== 1) {
							matched_text += 's';
						}

						matched_text += ' Available';

						$('.lp-result-count').html(matched_text);

						// reset the clear filters box
						$('.lp-filter-remove').addClass('hidden');

						// reset the criteria options to closed
						$('.lp-filter').removeClass('lp-filter-active');
						$('.lp-filter').data('state', 'closed');

						// hide the criteria container
						$('.lp-option-container').addClass('hidden');

						// clear the check 
						$('.lp-filter-check').removeClass('lp-filter-check-active');
					}
				});
			});

			$primary_container.on('click', '.lp-filter-check', function _enableCheckFilter(e) {
				var type    = $(this).data('type'),
				    typeArr = [];

				if (type.includes("-")) {
					typeArr = type.split("-");
					type    = typeArr[1];
				}

				e.preventDefault();

				if ($(this).hasClass('lp-filter-check-active')) {
					$(this).removeClass('lp-filter-check-active');
					attributes_arrays[type].splice(0, 1);
				} else {
					$(this).addClass('lp-filter-check-active');
					if (attributes_arrays[type].length === 0) {
						attributes_arrays[type].push(1);
					} else {
						attributes_arrays[type].splice(0, 1);
						attributes_arrays[type].push(1);
					}
				}

				filterSailings(attributes_arrays);
			});

			// ALL-INCLUSIVE FUNCTIONS -----------------------------------]
			$primary_container.on('click', '.lp-ais', function _selctAllInclusives(e) {
				$primary_container.html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading properties...');
				Adzuki.Ajax.get('/LivePlanner/properties/' + $(this).data('id'))
				.then(function _showProperties(content) {
					$primary_container.html(content);

					Adzuki.Form.initAjaxForm('LivePlannerProcessor');
					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-property', function _selectProperty(e) {
				var property_id = $(this).data('property-id');
				$primary_container.html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading property...');

				Adzuki.Ajax.get('/LivePlanner/property/' + property_id)
				.then(function _selectProperty(content) {
					$primary_container.html(content);

					Adzuki.Form.initAjaxForm('LivePlannerProcessor');
					Adzuki.Buckets.initAddButton($primary_container.find('.bucket-addto'));
					$('#lp-guide-box-container').css('display', 'block');

					self.setPageGuide();
					// self.refreshLog();

					$('.ai-reviews').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading reviews...');
					Adzuki.Ajax.get('/AllInclusiveProperties/reviews/' + property_id + '/1')
					.then(function success(response) {
						$('.ai-reviews').html(response);
					});
				});
			});

			$primary_container.on('click', '.lp-back-ais ', function _backToAis(e) {
				var vendor_id = $(this).data('vendor-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/properties/' + vendor_id)
				.then(function _backToAis(content) {
					$primary_container.html(content);

					Adzuki.Form.initAjaxForm('LivePlannerProcessor');

					self.setPageGuide();
					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-ais-overview-link', function _sendPropertyOverview(e) {
				var property_id = $(this).data('property-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPropertyOverview/' + property_id)
				.then(function _sendPropertyOverview(content) {
					toastMessage('Property Overview Sent');
					playSound();
					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-property-photo', function _sendPhoto(e) {
				var image_url   = $(this).data('image-url'),
					property_id = $(this).data('property-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPropertyPhoto/' + property_id + '/' + encodeURIComponent(image_url))
				.then(function _sendPhoto(content) {
					toastMessage('Property Photo Sent');
					playSound();
					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-all-property-photos', function _sendAllPhotos(e) {
				var property_id = $(this).data('property-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPropertyAllPhotos/' + property_id)
				.then(function _sendAllPhotos(content) {
					toastMessage('Property Photos Sent');
					playSound();
					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-amenities', function _sendAmenities(e) {
				var property_id = $(this).data('property-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendAmenities/' + property_id)
				.then(function _sendAmenities(content) {
					toastMessage('Property Amenities Sent');
					playSound();

					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-send-custom-property-pricing', function _sendCustomAiPricing(e) {
				var property_id  = $(this).data('property-id'),
					$modal       = $('#modalWindow');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/customPropertyPricing/'+ property_id)
				.then(function success(content) {
					$modal.find('.modal-title').text("Custom Pricing");
					$(".modal-dialog").addClass('modal-lg');
					$modal.find('.modal-body').html(content);

					Adzuki.Form.initAjaxForm('LivePlannerCustomPropertyPricing');

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			$primary_container.on('click', '.lp-ais-image', function _showAipPhotoGallery(e) {
				var property_id = $(this).data('property-id');

				showAipPhotoGallery(property_id);
			});

			// FIT/TEMPLATE FILTER FUNCTIONS -----------------------------------]
			$primary_container.on('click', '.lp-fit-button', function _filterFit(e) {
				var types = [];

				e.preventDefault();

				if ($(this).hasClass('lp-option-active')) {
					$(this).removeClass('lp-option-active');
					$(this).addClass('lp-option-inactive');
				} else {
					$(this).removeClass('lp-option-inactive');
					$(this).addClass('lp-option-active');
				}

				$('.lp-fit-button').each(function _getTypes() {
					if ($(this).hasClass('lp-option-active')) {
						types.push($(this).data('value'));
					}
				});

				// force at least "active" if none selected
				if (types.length === 0) {
					$('.lp-fit-button[data-value="active"]').addClass('lp-option-active');
					$('.lp-fit-button[data-value="active"]').removeClass('lp-option-inactive');

					types.push('active');
				}

				Adzuki.Ajax.post('/LivePlanner/sendType/fit/',
				{
					types: types
				})
				.then(function _sendType(content) {
					$('.live-planner-container').html(content);

					Adzuki.Form.initAjaxForm('LivePlannerProcessor');
					Adzuki.LivePlanner.setPageGuide();
					// Adzuki.LivePlanner.refreshLog();
					$('.live-planner-container')
					.on('click', '.back-to-travel-types', function _backToTravelTypes(e) {
						e.preventDefault();
						Adzuki.LivePlanner.showAllTravelTypes();
					});
				});
			});

			// FIT FUNCTIONS -----------------------------------]
			$primary_container.on('click', '.lp-fit', function _selectPackage(e) {
				var fit_builder_id = $(this).data('id'),
					$results_map,
					results_map, // eslint-disable-line no-unused-vars
					data;

				e.preventDefault();

				$primary_container.html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading Trip Summary...');

				Adzuki.Ajax.get('/LivePlanner/fitBuilder/' + fit_builder_id)
				.then(function _getPackage(content) {
					$primary_container.html(content);

					Adzuki.Form.initAjaxForm('LivePlannerProcessor');
					Adzuki.Buckets.initAddButton($primary_container.find('.bucket-addto'));

					$results_map = $(".fit-map");
					data         = $results_map.data('results');

					results_map = new Adzuki.Map($results_map, {
						zoom  : 10,
						styles: styles,
						init  : function map_init(map) {
							map.populate(data.map);
							map.drawGuidelines();
						}
					});

					webWeather();
					self.setPageGuide();
					// self.refreshLog();

					$('html, body').animate({
						scrollTop: $('.live-planner-container').offset().top
					}, 500);
				});
			});

			// whole package
			$primary_container.on('click', '.lp-fit-builder-entire-link', function _sendPackage(e) {
				var fit_builder_id = $(this).data('fit-builder-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPackage/' + fit_builder_id)
				.then(function _sendPackage(content) {
					toastMessage('Package Sent');
					playSound();
					// self.refreshLog();
				});
			});

			// overview
			$primary_container.on('click', '.lp-fit-builder-link', function _sendPackage(e) {
				var fit_builder_id = $(this).data('fit-builder-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPackage/' + fit_builder_id + '/overview')
				.then(function _sendPackage(content) {
					toastMessage('Package Overview Sent');
					playSound();
					// self.refreshLog();
				});
			});

			// pricing
			$primary_container.on('click', '.lp-fit-pricing-link', function _sendPackage(e) {
				var fit_builder_id = $(this).data('fit-builder-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPackage/' + fit_builder_id + '/pricing')
				.then(function _sendPackage(content) {
					toastMessage('Package Pricing Sent');
					playSound();
					// self.refreshLog();
				});
			});

			// insurance
			$primary_container.on('click', '.lp-fit-insurance-link', function _sendPackage(e) {
				var fit_builder_id = $(this).data('fit-builder-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPackage/' + fit_builder_id + '/insurance')
				.then(function _sendPackage(content) {
					toastMessage('Travel Insurance Information Sent');
					playSound();
					// self.refreshLog();
				});
			});

			// pricing by component
			$primary_container.on('click', '.lp-fit-pricing-table-link', function _sendPackage(e) {
				var fit_builder_id = $(this).data('fit-builder-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPackage/' + fit_builder_id + '/pricing_component:true')
				.then(function _sendPackage(content) {
					toastMessage('Package Pricing Sent');
					playSound();
					// self.refreshLog();
				});
			});

			// itinerary
			$primary_container.on('click', '.lp-fit-itinerary-link', function _sendPackage(e) {
				var fit_builder_id = $(this).data('fit-builder-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPackage/' + fit_builder_id + '/itinerary')
				.then(function _sendPackage(content) {
					toastMessage('Package Itinerary Sent');
					playSound();
					// self.refreshLog();
				});
			});

			// details
			$primary_container.on('click', '.lp-fit-details-link', function _sendPackage(e) {
				var fit_builder_id = $(this).data('fit-builder-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPackage/' + fit_builder_id + '/details')
				.then(function _sendPackage(content) {
					toastMessage('Package Details Sent');
					playSound();
					// self.refreshLog();
				});
			});

			// details for a day
			$primary_container.on('click', '.lp-fit-details-day-link', function _sendPackage(e) {
				var fit_builder_id = $(this).data('fit-builder-id'),
					date           = $(this).data('date'),
					offers_only    = $(this).data('offers-only'),
					url_append     = '/';

				e.preventDefault();

				if (actively_sending) {
					Adzuki.StatusMessage('error', 'Please wait to the last item you clicked has finished being sent');
				} else {
					actively_sending = true;

					if (offers_only === 1) {
						url_append += 'offers_only:1&offers_date:' + date;
					} else if (date !== '') {
						url_append += 'details_date:' + date;
					}

					Adzuki.Ajax.get('/LivePlanner/sendPackage/' + fit_builder_id + url_append)
					.then(function _sendPackage(content) {
						toastMessage('Package Detail Sent');
						playSound();
						// self.refreshLog();
					});
				}
			});

			// attachments
			$primary_container.on('click', '.lp-fit-attachments-link', function _sendPackage(e) {
				var fit_builder_id = $(this).data('fit-builder-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPackage/' + fit_builder_id + '/attachments')
				.then(function _sendPackage(content) {
					toastMessage('Package Attachments Sent');
					playSound();
					// self.refreshLog();
				});
			});

			// image gallery
			$primary_container.on('click', '.lp-fit-builder-carousel-image', function _showGallery() {
				var component_id  = $(this).data('component-id'),
					controller    = $(this).data('controller'),
					hotel_gallery = null;

				Adzuki.Ajax.post('/' + controller + '/galleryImages/' + component_id)
				.then(function sucess(response) {
					var images         = response;
					var gallery_images = [];

					if (images.length === 0) {
						return;
					}

					$.each(images, function onEachImage(i, image) {
						gallery_images.push({
							src    : image.src,
							thumb  : image.thumb,
							subHtml: image.subHtml,
						});
					});

					hotel_gallery = lightGallery($('.lp-fit-builder-carousel-image')[0], {
						licenseKey       : 'github',
						download         : false,
						plugins          : [lgThumbnail],
						dynamic          : true,
						thumbnail        : true,
						toggleThumb      : true,
						allowMediaOverlap: true,
						dynamicEl        : gallery_images,
					});

					hotel_gallery.openGallery();
				});
			});

			// FIT TEMPLATE FUNCTIONS -----------------------------------]
			$primary_container.on('click', '.lp-fit-template', function _selectPackageTemplate(e) {
				var fit_builder_template_id = $(this).data('id'),
					$results_map,
					results_map, // eslint-disable-line no-unused-vars
					data;

				e.preventDefault();

				$primary_container.html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading Trip Summary Template...');

				Adzuki.Ajax.get('/LivePlanner/fitBuilderTemplate/' + fit_builder_template_id)
				.then(function _getPackageTemplate(content) {
					$primary_container.html(content);

					Adzuki.Form.initAjaxForm('LivePlannerProcessor');
					Adzuki.Buckets.initAddButton($primary_container.find('.bucket-addto'));

					$results_map = $(".fit-map");
					data         = $results_map.data('results');
					results_map  = new Adzuki.Map($results_map, {
						zoom  : 10,
						styles: styles,
						init  : function map_init(map) {
							map.populate(data.map);
							map.drawGuidelines();
						}
					});

					self.setPageGuide();
					// self.refreshLog();

					$('html, body').animate({
						scrollTop: $('.live-planner-container').offset().top
					}, 500);
				});
			});

			// whole package template
			$primary_container.on('click', '.lp-fit-builder-template-entire-link', function _sendPackageTemplate(e) {
				var fit_builder_template_id = $(this).data('fit-builder-template-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPackageTemplate/' + fit_builder_template_id)
				.then(function _sendPackageTemplate(content) {
					toastMessage('Package Template Sent');
					playSound();
					// self.refreshLog();
				});
			});

			// template overview
			$primary_container.on('click', '.lp-fit-builder-template-link', function _sendPackageTemplate(e) {
				var fit_builder_template_id = $(this).data('fit-builder-template-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPackageTemplate/' + fit_builder_template_id + '/overview')
				.then(function _sendPackageTemplate(content) {
					toastMessage('Package Template Overview Sent');
					playSound();
					// self.refreshLog();
				});
			});

			// template itinerary
			$primary_container.on('click', '.lp-fit-template-itinerary-link', function _sendPackageTemplate(e) {
				var fit_builder_template_id = $(this).data('fit-builder-template-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPackageTemplate/' + fit_builder_template_id + '/itinerary')
				.then(function _sendPackageTemplate(content) {
					toastMessage('Package Template Itinerary Sent');
					playSound();
					// self.refreshLog();
				});
			});

			// template details
			$primary_container.on('click', '.lp-fit-template-details-link', function _sendPackageTemplate(e) {
				var fit_builder_template_id = $(this).data('fit-builder-template-id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendPackageTemplate/' + fit_builder_template_id + '/details')
				.then(function _sendPackageTemplate(content) {
					toastMessage('Package Template Details Sent');
					playSound();
					// self.refreshLog();
				});
			});

			// template details for a day
			$primary_container.on('click', '.lp-fit-template-details-day-link', function _sendPackageTemplate(e) {
				var fit_builder_template_id = $(this).data('fit-builder-template-id'),
					day_number              = $(this).data('day');

				e.preventDefault();

				if (actively_sending) {
					Adzuki.StatusMessage('error', 'Please wait to the last item you clicked has finished being sent');
				} else {
					actively_sending = true;

					Adzuki.Ajax.get('/LivePlanner/sendPackageTemplate/' + fit_builder_template_id + '/day_number:' + day_number)
					.then(function _sendPackageTemplate(content) {
						toastMessage('Package Template Day ' + day_number + ' Details Sent');
						playSound();
						// self.refreshLog();
					});
				}
			});

			// COLLECTION FUNCTIONS -----------------------------------]
			$primary_container.on('click', '.lp-collections', function _selectCollectionSupplier(e) {
				var collection_supplier_id = $(this).data('collection-supplier-id');

				e.stopPropagation();
				e.stopImmediatePropagation();
				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/collections/' + collection_supplier_id)
				.then(function _selectCollectionSuppliers(content) {
					$primary_container.html(content);
					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-collection', function _selectCollection(e) {
				var collection_id = $(this).data('collection-id');

				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();

				Adzuki.Ajax.get('/LivePlanner/collection/' + collection_id)
				.then(function _selectCollection(content) {
					$primary_container.html(content);

					self.setPageGuide();
					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-collection-item-send', function _sendCollectionItems(e) {
				var collection_item_id   = $(this).data('collection-item-id'),
					collection_item_type = $(this).data('content-type');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendCollectionItem/' + collection_item_id + '/' + collection_item_type)
				.then(function _sendCollectionItems(content) {
					toastMessage('Collection items sent');
					playSound();
					// self.refreshLog();
				});
			});

			$primary_container.on('click', '.lp-collection-preview', function _previewCollection(e) {
				var collection_id = $(this).data('id'),
					$modal       = $('#modalWindow');

				e.preventDefault();
				e.stopImmediatePropagation();

				$modal.find('.modal-title').text('Preview collection');

				Adzuki.Ajax.get('/LivePlanner/collectionSupplierPreview/' + collection_id)
				.then(function _showCollectionPreview(response) {
					$modal.find('.modal-body').html(response);
					$modal.modal('show');
				});
			});

			$('#modalWindow').on('click', '.lp-collection', function _selectCollection(e) {
				var collection_id = $(this).data('collection-id');

				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();

				$('#modalWindow').modal('toggle');

				Adzuki.Ajax.get('/LivePlanner/collection/' + collection_id)
				.then(function _selectCollection(content) {
					$primary_container.html(content);

					self.setPageGuide();
					// self.refreshLog();
				});
			});

			// every 30 seconds, check if the client is still there if not, end the session
			active_interval = setInterval(checkIfActive, active_timeout);

			// ask agent if they want to start video right away
			if (start_video && zoom_support) {
				Adzuki.CustomConfirm({
					title  : 'Start Video',
					content: 'Would you like to start this session using video?',
					confirm: function confirm() {
						$('.lp-start-video').trigger('click', true);
					},
					cancel: function cancel() {
						// nothing
					}
				});
			}
		});

		// WEB FUNCTIONS ------------------||
		Adzuki.onload(['/LivePlanner/index'], function onload()
		{
			// detect smaller screen size and suggest fullscreen
			if (screen.width < screen_min_width || screen.height < screen_min_height) {
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'For session optimization we recommend that Full Screen mode is enabled for your browser. Would you like to enable?',
					confirm: function confirm() {
						$('.lp-full-screen').trigger('click');
					}
				});
			}

			$('body').addClass('lp-session');

			$(window).on('beforeunload', function _onBeforeUnload(e) {
				if (redirect_warning) {
					e.preventDefault();

					return 'You are about to leave the LivePlanner session. Are you sure you want to continue?';
				}
			});

			// check if there is an ongoing meeting if so, show the button to re-join the call
			ongoingMeetingCheckInWebsite();

			$primary_container.on('click', '.live-planner-cruise-line', function _selectCruiseLine(e) {
				var cruise_line_id = $(this).data('id');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/sendCruiseLine/' + cruise_line_id)
				.then(function _sendCruiseLine(content) {
					// nothing to do
				});
			});

			$primary_container.on('click', '.favorite', function _favorite(e) {
				var item_id    = $(this).data('item-id'),
					redirect   = $(this).data('uri'),
					type       = $(this).data('type'),
					obj        = $(this),
					unfavorite = false;

				e.preventDefault();

				if (obj.hasClass('favorite-disabled')) {
					Adzuki.Ajax.get('/ClientFavorites/remove/' + item_id + '/' + type + '/' + redirect).then(function success(response) {
						obj.html('<i class="fas fa-fw fa-heart"></i> Favorite This');
						obj.removeClass('favorite-disabled');
					});

					unfavorite = true;
				} else {
					Adzuki.Ajax.get('/ClientFavorites/add/' + item_id + '/' + type + '/' + redirect).then(function success(response) {
						obj.html('<i class="far fa-fw fa-heart"></i> Unfavorite');
						obj.addClass('favorite-disabled');
					});

					unfavorite = false;
				}

				Adzuki.Ajax.get('/LivePlanner/favorited/' + item_id + '/' + type + '/' + unfavorite)
				.then(function _sendFavorite(content) {
					// nothing to do
				});
			});

            $primary_container.on('click', '.lp-content-details', function _showContentDetail(e) {
                var name        = $(this).data('name'),
                    image       = $(this).data('image'),
                    alt_image   = $(this).data('alt-image'),
                    description = $(this).data('description'),
                    embed_code  = $(this).data('embed-code'),
                    $modal      = $('#modalWindow'),
                    content     = '';

                e.preventDefault();
                if (embed_code) {
                    content += '<div class="embed-responsive embed-responsive-16by9">' + $(this).data('embed-code') + '</div>';
                } else if (image) {
					content += '<div><img src="' + image + '" class="img-responsive" style="max-height: 800px"></div>';
					content += '<div>' + description + '</div>';
				} else if (description) {
					content += '<div>' + description + '</div>';
				}

                if (alt_image && alt_image.length > 0) {
                    image = alt_image;
                }

                $modal.find('.modal-title').text(name);
                $(".modal-dialog").addClass('modal-lg');
                $modal.find('.modal-body').html(content);

                $modal.on('hidden.bs.modal', function _restoreModal() {
                    $modal.removeClass('wide').off('hidden.bs.modal');
                }).modal('show');

                Adzuki.Ajax.get('/LivePlanner/clientViewed/' + escape(name) + '/' + encodeURIComponent(image))
                    .then(function success(response) {
                        // do nothing
                    });
            });

			$primary_container.on('click', '.lp-content-details-images', function _showContentDetail(e) {
				var name        = $(this).data('name'),
					image       = $(this).data('image'),
					image_id    = $(this).data('id'),
					$modal      = $('#modalWindow');

				e.preventDefault();

				Adzuki.Ajax.get('/LivePlanner/clientViewed/' + escape(name) + '/' + encodeURIComponent(image) + '/' + image_id)
					.then(function success(response) {

						$modal.find('.modal-title').text("Collection Images");
						$(".modal-dialog").addClass('lp-carousel');
						$modal.find('.modal-body').html(response);

						// Call Carousel Initializer
						$modal.on('shown.bs.modal', function initCarousel() {
							$('#liveplanner-image-list').slick({
								dots          : true,
								slidesToShow  : 1,
								arrows        : true,
								slidesToScroll: 1,
								autoplay      : false,
								autoplaySpeed : 2000,
								responsive    : [
									{
										breakpoint: 992,
										settings  : {
											slidesToShow: 1,
										}
									},
									{
										breakpoint: 830,
										settings  : {
											slidesToShow: 1,
										}
									},
									{
										breakpoint: 768,
										settings  : {
											slidesToShow: 1,
										}
									}
								]
							});
						});

						$modal.on('hidden.bs.modal', function _restoreModal() {
							$modal.removeClass('lp-carousel').off('hidden.bs.modal');
						}).modal('show');
					});
			});

			$primary_container.on('click', '.fit-builder-carousel-image', function _showGallery() {
				var component_id  = $(this).data('component-id'),
					controller    = $(this).data('controller'),
					hotel_gallery = null;

				Adzuki.Ajax.post('/' + controller + '/galleryImages/' + component_id)
				.then(function sucess(response) {
					var images         = response;
					var gallery_images = [];

					if (images.length === 0) {
						return;
					}

					$.each(images, function onEachImage(i, image) {
						gallery_images.push({
							src    : image.src,
							thumb  : image.thumb,
							subHtml: image.subHtml,
						});
					});

					hotel_gallery = lightGallery($('.fit-builder-carousel-image')[0], {
						licenseKey       : 'github',
						download         : false,
						plugins          : [lgThumbnail],
						dynamic          : true,
						thumbnail        : true,
						toggleThumb      : true,
						allowMediaOverlap: true,
						dynamicEl        : gallery_images,
					});

					hotel_gallery.openGallery();
				});
			});

			$primary_container.on('click', '.lp-ais-image', function _showAipPhotoGallery(e) {
				var property_id = $(this).data('property-id');

				showAipPhotoGallery(property_id);
			});

			$('.modal').on('hide.bs.modal', function _silenceYouFools() {
				$(".modal iframe").attr("src", '');
				$(".modal audio").attr("src", '');
				$(".modal video").attr("src", '');
				$('.modal').find('.modal-body').html('<iframe frameborder="0" credentialless></iframe>');
			});

			// if the video window is open, just bring the video window back to the front
			// otherwise, rejoin since the meeting is ongoing
			$('.lp-web-join-video').on('click', function _joinVideo(e) {
				var client_id = $(this).data('client-id');
				var url       = '/LivePlanner/videoCall/' + client_id;

				e.preventDefault();

				if (lp_video_window && !lp_video_window.closed) {
					lp_video_window.focus();
				} else {
					lp_video_window = window.open(
						Adzuki.base_uri + url,
						'lp_video_window',
						'popup=1,width=1380,height=850'
					);

					// display button that brings the video window into the front
					$('.lp-web-switch-to-video').removeClass('hidden');
					$('.lp-web-join-video').addClass('hidden');
				}
			});

			// bring the video window back to the front
			$('.lp-web-switch-to-video').on('click', function _switchToVideoWindow(e) {
				var client_id = $(this).data('client-id');
				var url       = '/LivePlanner/videoCall/' + client_id;

				e.preventDefault();

				if (lp_video_window && !lp_video_window.closed) {
					lp_video_window.focus();
				} else {
					Cookies.set('lp_confirm_video_close', 0);

					// we lost the reference to the window (most likely due to a refresh)
					// try to get the window back since it should be there
					lp_video_window = window.open(
						Adzuki.base_uri + url,
						'lp_video_window',
						'popup=1,width=1380,height=850'
					);

					lp_video_window.focus();
				}
			});
		});

		$primary_container.on('click', '.lp-collection-item-extra', function _showGallery(e) {
			e.preventDefault();

			let component_id  = $(this).data('component-id'),
				$modal        = $('#modalWindow');

			Adzuki.Ajax.get('/LivePlanner/showCollectionExtraImages/' + component_id)
				.then(function success(response) {
					$modal.find('.modal-title').text('Collection Images');
					$(".modal-dialog").addClass('lp-carousel');
					$modal.find('.modal-body').html(response);

					// Call Carousel Initializer
					$modal.on('shown.bs.modal', function initCarousel() {
						$('#liveplanner-image-list').slick({
							dots          : true,
							slidesToShow  : 1,
							arrows        : true,
							slidesToScroll: 1,
							autoplay      : false,
							autoplaySpeed : 2000,
							responsive    : [
								{
									breakpoint: 992,
									settings  : {
										slidesToShow: 1,
									}
								},
								{
									breakpoint: 830,
									settings  : {
										slidesToShow: 1,
									}
								},
								{
									breakpoint: 768,
									settings  : {
										slidesToShow: 1,
									}
								}
							]
						});
					});

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('lp-carousel').off('hidden.bs.modal');
					}).modal('show');
				});
		});

		// bound functions based on where the summary goes
		$('.live-planner-summary-container').on('click', '.live-planner-summary-control-right', function _scrollRight(e) {
			summaryScrollRight($(this));
		});

		$('.live-planner-summary-container').on('click', '.live-planner-summary-control-left', function _scrollLeft(e) {
			summaryScrollLeft($(this));
		});

		$('#modalWindow').on('click', '.live-planner-summary-control-right', function _scrollRight(e) {
			summaryScrollRight($(this));
		});

		$('#modalWindow').on('click', '.live-planner-summary-control-left', function _scrollLeft(e) {
			summaryScrollLeft($(this));
		});

		$primary_container.on('click', '.live-planner-summary-control-right', function _scrollRight(e) {
			summaryScrollRight($(this));
		});

		$primary_container.on('click', '.live-planner-summary-control-left', function _scrollLeft(e) {
			summaryScrollLeft($(this));
		});

		// show day-by-day for cruise tours
		$primary_container.on('click', '.cruise-tour-days', function cruiseTourDays(e) {
			var $self    = $(this),
				$icon    = $self.find('i'),
				tour_id  = $self.data("itinerary-cruise-tour-id"),
				$details = $('#details-' + tour_id);

			e.preventDefault();

			$details.toggleClass('hidden');
			$icon.toggleClass('fa-minus-square');
			$icon.toggleClass('fa-plus-square');

			if ($icon.hasClass('fa-plus-square')) {
				$self.attr('data-original-title', 'Expand Cruisetour Details');
				$icon.attr('data-original-title', 'Expand Cruisetour Details');
			} else {
				$self.attr('data-original-title', 'Collapse Cruisetour Details');
				$icon.attr('data-original-title', 'Collapse Cruisetour Details');
			}
		});
	};

	function checkIfActive()
	{
		var web_session_id = $('#liveplannerprocessor-web_session_id').val();

		if (!web_session_id) {
			return;
		}

		// update participant count each time
		updateParticipantCount();

		Adzuki.Ajax.get('/LivePlanner/check/' + web_session_id)
		.then(function _checkSession(response) {
			if (response.found === false) {
				if (response.group_session) {
					// stop the checkIfActive() timer
					clearInterval(active_interval);
					active_interval = null;

					// this is a group session, ask the agent what to do next
					Adzuki.CustomConfirm({
						title  : 'Primary Client Left',
						content: 'Your Primary Client has been disconnected from the session. Would you like to designate a participant as the new Primary Client for this session?',
						confirm: function confirm() {
							openParticipantsModal();
						},
						cancel: function cancel() {
							// end the video meeting if it was started
							if ($('.lp-start-video').hasClass('hidden')) {
								$('.lp-end-video').trigger('click', true);
							}

							Adzuki.Ajax.get('/LivePlanner/endSession/')
							.then(function _endSession(response) {
								redirect_warning  = false;
								document.location = Adzuki.base_uri + '/LivePlanner/index';
							});
						}
					});
				} else {
					// not a group session, just end the session
					Adzuki.StatusMessage(null, 'Your client has been disconnected from the session. You will be re-directed in 5 seconds.', 'Client left');

					// self.refreshLog();

					setTimeout(
						function _redirection () {
							// end the video meeting if it was started
							if ($('.lp-start-video').hasClass('hidden')) {
								$('.lp-end-video').trigger('click', true);
							}

							Adzuki.Ajax.get('/LivePlanner/endSession/')
							.then(function _endSession(response) {
								redirect_warning  = false;
								document.location = Adzuki.base_uri + '/LivePlanner/index';
							});
						},
						5000
					);
				}
			}
		});
	}

	function toggleFullscreen(event)
	{
		if ((document.fullScreenElement && document.fullScreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
			if (document.documentElement.requestFullScreen) {
				document.documentElement.requestFullScreen();
			} else if (document.documentElement.mozRequestFullScreen) { /* Firefox */
				document.documentElement.mozRequestFullScreen();
			} else if (document.documentElement.webkitRequestFullScreen) {   /* Chrome, Safari & Opera */
				document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
			} else if (document.msRequestFullscreen) { /* IE/Edge */
				document.documentElement.msRequestFullscreen();
			}
		} else {
			if (document.cancelFullScreen) { // eslint-disable-line no-lonely-if
				document.cancelFullScreen();
			} else if (document.mozCancelFullScreen) { /* Firefox */
				document.mozCancelFullScreen();
			} else if (document.webkitCancelFullScreen) {   /* Chrome, Safari and Opera */
				document.webkitCancelFullScreen();
			} else if (document.msExitFullscreen) { /* IE/Edge */
				document.msExitFullscreen();
			}
		}
	}

	if (document.addEventListener) {
		document.addEventListener('fullscreenchange', exitHandler, false);
		document.addEventListener('mozfullscreenchange', exitHandler, false);
		document.addEventListener('MSFullscreenChange', exitHandler, false);
		document.addEventListener('webkitfullscreenchange', exitHandler, false);
	}

	function endAgentVideo($end_btn)
	{
		$('.lp-switch-video-row').addClass('hidden');
		$('.lp-start-video').removeClass('hidden').data('started', 0);
		$end_btn.addClass('hidden').data('ended', 1);

		Adzuki.LPVideo.endZoomMeeting();
		Adzuki.Ajax.get('/LivePlanner/endVideo/');

		if (lp_video_window && !lp_video_window.closed) {
			lp_video_window.close();
		}
	}

	function endSessionAndVideo()
	{
		// end the video meeting if it was started
		if ($('.lp-start-video').hasClass('hidden')) {
			$('.lp-end-video').trigger('click', true);
		}

		Adzuki.Ajax.get('/LivePlanner/endSession/')
		.then(function _endSession(content) {
			redirect_warning  = false;
			document.location = Adzuki.base_uri + '/LivePlanner/sessionDetails';
		});
	}

	function exitHandler()
	{
		if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
			if ($('.lp-session-full-screen').length > 0) {
				$('.navbar').removeClass('hidden');
				$('.sidebar').removeClass('hidden');
				$('.breadcrumb-container').removeClass('hidden');
				$('main').css('margin-top', '51px');

				$('.lp-session-full-screen').data('state', 'normal');
				$('.lp-session-full-screen').html('<i class="fas fa-fw fa-expand"></i> Full Screen</a>');
			}

			if ($('.lp-full-screen').length > 0) {
				$('.social').css('display', '');
				$('.sheet-header').css('display', '');
				$('.lp-full-screen').html('<i class="fas fa-fw fa-expand"></i> Full Screen Page</a>');
			}
		}
	}

	function ongoingMeetingCheckInWebsite()
	{
		var zoom_support = Adzuki.LPVideo.browserSupportsZoomAudio();

		Adzuki.Ajax.post('/LivePlanner/ongoingMeeting/1')
		.then(function ongoingMeeting(response) {
			if (response.error) {
				return;
			}

			// client is already in the meeting, only show button to show the video window
			if (response.client_in_meeting) {
				$('.lp-web-switch-to-video').removeClass('hidden');
				return;
			}

			// client should be able to join the meeting, show button
			$('.lp-web-join-video').removeClass('hidden');

			// if the secondary client is joining for the first time
			// and there is an ongoing meeting in which he/she has not
			// joined yet, then ask if the client wants to join
			if (zoom_support && response.start_video) {
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'Would you like to join this consultation with video?',
					confirm: function confirm() {
						$('.lp-web-join-video')
							.trigger('click')
							.addClass('hidden');
					},
					cancel: function cancel() {
						// nothing to do
					}
				});
			}
		});
	}

	function openParticipantsModal()
	{
		var $modal = $('#modalWindow');

		if (participants_interval === null) {
			participants_interval = setInterval(openParticipantsModal, active_timeout);
		}

		Adzuki.Ajax.get('/LivePlanner/sessionParticipants/')
		.then(function success(response) {
			$modal.find('.modal-title').text('LivePlanner Session Participants');
			$modal.find('.modal-body').html(response);
			$modal.modal('show');

			// if the agent closes the modal, update the appropriate timers
			$modal.on('hide.bs.modal', function _modalClosed(e) {
				// stop the timer to update this modal since it's now closed
				if (participants_interval) {
					clearInterval(participants_interval);
					participants_interval = null;
				}

				// check the active interval, and re-enable only if it's disabled
				if (active_interval === null) {
					active_interval = setInterval(checkIfActive, active_timeout);
				}

				$modal.off('hide.bs.modal');
			});

			// handler to resume the session for a participant
			$('.resume-participant-btn').off().on('click', function _onResumeClick(e) {
				var client_name    = $(this).data('client-name');
				var client_session = $(this).data('client-session-id');

				e.preventDefault();

				if (participants_interval) {
					clearInterval(participants_interval);
					participants_interval = null;
				}

				// ask agent to confirm before sending the resume
				Adzuki.CustomConfirm({
					content: 'Would you like to resume this session with ' + client_name + '?',
					confirm: function _confirm() {
						Adzuki.Ajax.get('/LivePlanner/resume/' + client_session)
						.then(function _resume(response) {
							Adzuki.StatusMessage('success', 'The invitation to resume the session has been sent to ' + client_name + '.');

							$modal.modal('hide');
						});
					},
					cancel: function _cancel() {
						if (participants_interval === null) {
							participants_interval = setInterval(openParticipantsModal, active_timeout);
						}
					}
				});
			});

			// handler to set the client as the new primary client
			$('.set-primary-participant-btn').off().on('click', function _onPrimaryClick(e) {
				var client_name    = $(this).data('client-name');
				var client_id      = $(this).data('client-id');
				var client_session = $(this).data('client-session-id');

				e.preventDefault();

				if (participants_interval) {
					clearInterval(participants_interval);
					participants_interval = null;
				}

				// ask agent to confirm before designating a new primary client
				Adzuki.CustomConfirm({
					content: 'Would you like to make ' + client_name + ' the new primary client for this session?',
					confirm: function _confirm() {
						var url = '/LivePlanner/designateNewPrimaryClient/';
						url    += client_id + '/';
						url    += client_session;

						Adzuki.Ajax.get(url)
						.then(function _designatePrimary(response) {
							var new_title = null;

							if (response.error) {
								Adzuki.StatusMessage('error', response.error);
								return;
							}

							new_title = 'LivePlanner Session with ' + response.primary_client;

							Adzuki.StatusMessage('success', client_name + ' is the new primary client for this session.');

							$('h3.page-title').text(new_title);
							$(document).prop('title', new_title);
							$('#liveplannerprocessor-web_session_id').val(client_session);

							$modal.modal('hide');
						});
					},
					cancel: function _cancel() {
						if (participants_interval === null) {
							participants_interval = setInterval(openParticipantsModal, active_timeout);
						}
					}
				});
			});
		});
	}

	function playSound()
	{
		Adzuki.Ajax.get('/LivePlanner/getAgentSound')
		.then(function _getAgentSound(response) {
			var sound_path = response.sound;
			var audio      = null;
			var mp3_source = null;
			var wav_source = null;

			$('.live-planner-container').find('audio.lp-sound').remove();

			if (!sound_path) {
				return;
			}

			// create sources
			mp3_source = $('<source/>').attr({
				type: 'audio/mpeg3',
				src : sound_path + '.mp3',
			});

			wav_source = $('<source/>').attr({
				type: 'audio/x-wav',
				src : sound_path + '.wav',
			});

			// create audio tag, append to body and play it
			audio = $('<audio></audio>').attr('class', 'lp-sound');
			audio.append(mp3_source);
			audio.append(wav_source);

			$('.live-planner-container').append(audio);

			audio.get(0).play();
		});
	}

	function showDestinationGuides()
	{
		var $modal = $('#modalWindow');
		
		Adzuki.Ajax.get('/LivePlanner/sessionLibraryDestinationGuides/')
		.then(function success(content) {
			$modal.find('.destination-guides-contents').html(content);

			Adzuki.Form.initAjaxForm('DestinationGuideFilter');
		});
	}

	function showCollections()
	{
		var $modal = $('#modalWindow');
		
		Adzuki.Ajax.get('/LivePlanner/sessionLibraryCollections/')
		.then(function success(content) {
			$modal.find('.collection-previews-contents').html(content);

			Adzuki.Form.initAjaxForm('CollectionFilter');
		});
	}

	function showVideoLibrary()
	{
		var $modal = $('#modalWindow');
		
		Adzuki.Ajax.get('/LivePlanner/sessionLibraryVideos/')
		.then(function success(content) {
			$modal.find('.video-library-contents').html(content);

			Adzuki.Form.initAjaxForm('VideoFilter');
		});
	}

	function showSignatureMicrosites(category)
	{
		var $modal = $('#modalWindow');
		
		if (category === undefined) {
			category = ''; // eslint-disable-line no-param-reassign
		}

		Adzuki.Ajax.get('/LivePlanner/sessionLibrarySignatureMicrosites/' + category)
		.then(function success(content) {
			$modal.find('.signature-microsites-contents').html(content);
		});
	}

	function updateParticipantCount()
	{
		Adzuki.Ajax.get('/LivePlanner/getParticipantCount/')
		.then(function _getParticipantCount(response) {
			$('span.lp-session-participant-count').text(response.count);
		});
	}

	$(document).ready(function documentReady()
	{
		if (
			(!Adzuki.prod && !Adzuki.dev) ||
			(Adzuki.app !== 'Web' && !Adzuki.cpcentral) ||
			(Adzuki.cpcentral && Adzuki.mobile_login)
		) {
			return;
		}

		// Full screen page button, only used on the agent's website
		if ($('.lp-full-screen').length > 0) {
			$('.lp-full-screen').click(function _goFullScreen(e) {
				var hidden = false;

				e.preventDefault();

				if ($('.social').css('display') === 'none') {
					$('.social').css('display', '');
					$('.sheet-header').css('display', '');

					toggleFullscreen(e);
					hidden = false;
				} else {
					$('.social').css('display', 'none');
					$('.sheet-header').css('display', 'none');

					toggleFullscreen(e);
					hidden = true;
				}

				if (hidden === true) {
					$(this).html('<i class="fas fa-fw fa-compress"></i> Exit Full Screen Page</a>');
				} else {
					$(this).html('<i class="fas fa-fw fa-expand"></i> Full Screen Page</a>');
				}
			});
		}

		// Return to website button, only used on the agent's website
		if ($('.lp-return-website').length > 0) {
			$('.lp-return-website').on('click', function _returnToWebsite(e) {
				var confirm_message = 'You are about to leave the LivePlanner session';

				e.preventDefault();
				e.stopImmediatePropagation();

				if (lp_video_window && !lp_video_window.closed) {
					confirm_message += ' and video';
				}

				confirm_message += '. Would you like to continue?';

				if (window.location.href.indexOf('endSession') === -1) {
					Adzuki.CustomConfirm({
						title  : 'Decision Time',
						content: confirm_message,
						confirm: function confirm() {
							Adzuki.Ajax.get('/LivePlanner/returned').then(function success(response) {
								redirect_warning = false;

								if (lp_video_window) {
									Cookies.set('lp_confirm_video_close', 0);

									lp_video_window.close();
									lp_video_window = null;
								}

								document.location = Adzuki.base_uri + '/';
							});
						}
					});
				} else {
					document.location = Adzuki.base_uri + '/';
				}
			});
		}

		// Go to My Account button, only used on the agent's website
		if ($('.lp-goto-account').length > 0) {
			$('.lp-goto-account').on('click', function _goToAccount(e) {
				var confirm_message = 'You are about to leave the LivePlanner session';

				e.preventDefault();
				e.stopImmediatePropagation();

				if (lp_video_window && !lp_video_window.closed) {
					confirm_message += ' and video';
				}

				confirm_message += '. Would you like to continue?';

				if (window.location.href.indexOf('endSession') === -1) {
					Adzuki.CustomConfirm({
						title  : 'Decision Time',
						content: confirm_message,
						confirm: function confirm() {
							Adzuki.Ajax.get('/LivePlanner/returned').then(function success(response) {
								redirect_warning = false;

								if (lp_video_window) {
									Cookies.set('lp_confirm_video_close', 0);

									lp_video_window.close();
									lp_video_window = null;
								}

								document.location = Adzuki.base_uri + '/LivePlanner/landing';
							});
						}
					});
				} else {
					document.location = Adzuki.base_uri + '/LivePlanner/landing';
				}
			});
		}

		Adzuki.LivePlanner = new LivePlanner();

		// this is only used in the agent's website
		// if there's a resume, we grab the last event (stored in a hidden field) and redirect them to it
		if ($('#resume-id').length > 0 && $('#resume-id').val() !== '') {
			Adzuki.LivePlanner.webEventHandler($.parseJSON($('#resume-id').val()));
			$('#resume-id').val('');
		}
	});
}(jQuery, window.Adzuki || {}));
